// ── Cart Page Patch — Global Scope ──
function patchCartPage() {
    document.querySelectorAll('.cart-item').forEach(row => {
        const props = {};
        row.querySelectorAll('.product-option').forEach(opt => {
            const text = opt.textContent.trim();
            const [key, ...rest] = text.split(':');
            if (key && rest.length) props[key.trim()] = rest.join(':').trim();
        });

        if (!props['Order Total']) return;
        if (row.querySelector('.ri-cart-breakdown')) return;

        const priceCell = row.querySelector('.cart-item__totals, .cart-item__price');
        if (!priceCell) return;

        const breakdown = document.createElement('div');
        breakdown.className = 'ri-cart-breakdown';
        breakdown.style.cssText = 'font-size:12px; margin-top:6px; line-height:1.8;';
        breakdown.innerHTML = `
            <div>Unit Price: <strong>${props['Unit Price'] || ''}</strong></div>
            <div>Subtotal: <strong>${props['Subtotal'] || ''}</strong></div>
            <div>Setup Fee: <strong>${props['Setup Fee'] || ''}</strong></div>
            <div style="color:green;font-weight:bold;">Order Total: ${props['Order Total'] || ''}</div>
        `;
        priceCell.appendChild(breakdown);
    });
}

if (window.location.pathname === '/cart') {
    document.addEventListener('DOMContentLoaded', patchCartPage);
    setTimeout(patchCartPage, 300);
    setTimeout(patchCartPage, 500);
}
// ── End Cart Page Patch ──



// ROMAN FINAL FIX V2 - 2026-06-23 - safe global calls
console.log("ROMAN: script loaded ✅", window.location.pathname);


(function () {
  
  // -----------------------------
  // 0) Wait for ROMAN_META (tiers must exist)
  // -----------------------------
  async function waitForRomanMeta(maxMs = 4000) {
    const start = Date.now();
    while (Date.now() - start < maxMs) {
      if (
        window.ROMAN_META &&
        Array.isArray(window.ROMAN_META.tiers) &&
        window.ROMAN_META.tiers.length
      ) {
        return true;
      }
      await new Promise((r) => setTimeout(r, 50));
    }
    return false;
  }

  // -----------------------------
  // 1) STATE + helpers
  // -----------------------------
window.STATE = {
    product: null,
    colorIndex: -1,
    sizeIndex: -1,
    tiers: [],
    setupFee: 0,
    groupQty: 1,
    sizeUpchargeMap: {},
    selectedColor: null,
    selectedVariant: null,
    baseVariantPrice: 0,
    variantsBySize: {},
    activeQtyInput: null,
};
const STATE = window.STATE;

  const money = (n) => `$${Number(n || 0).toFixed(2)}`;

  function normalizeTiers(maybe) {
    if (!Array.isArray(maybe)) return [];
    return maybe
      .map((t) => ({
        min: Number(t?.min),
        price: Number(t?.price),
        sale_price: Number(t?.sale_price),
      }))
      .filter((t) => Number.isFinite(t.min) && t.min > 0)
      .sort((a, b) => a.min - b.min);
  }

  // ✅ robust JSON / object loader for size_upcharge
  function normalizeUpcharge(maybe) {
    let su = maybe;

    // liquid might output as string sometimes
    if (typeof su === "string") {
      try {
        su = JSON.parse(su);
      } catch (e) {
        su = {};
      }
    }

    // allow null/undefined
    if (!su || typeof su !== "object" || Array.isArray(su)) return {};
    return su;
  }

  function normalizeRiList(value) {
    if (Array.isArray(value)) {
      return value.map((item) => String(item || "").trim()).filter(Boolean);
    }

    if (value && typeof value === "object" && "value" in value) {
      return normalizeRiList(value.value);
    }

    return String(value || "")
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  }

  function riMetaBool(value, fallback = false) {
    if (typeof value === "boolean") return value;
    if (value == null || value === "") return fallback;
    if (typeof value === "number") return value !== 0;

    const normalized = String(value).trim().toLowerCase();
    if (["true", "1", "yes", "on"].includes(normalized)) return true;
    if (["false", "0", "no", "off"].includes(normalized)) return false;

    return fallback;
  }

  function getFallbackPrintLocations(productOrHandle) {
    const handle = String(
      typeof productOrHandle === "string"
        ? productOrHandle
        : productOrHandle?.handle || ""
    ).trim().toLowerCase();

    if (!handle.includes("bag")) return [];

    return ["Front", "Back"];
  }

  function getResolvedPrintLocations(productOrHandle) {
    const configuredLocations = normalizeRiList(window.IMPRINT_LOCATIONS);
    if (configuredLocations.length) return configuredLocations;
    return getFallbackPrintLocations(productOrHandle);
  }

function loadMetaIntoState() {
  const meta = window.ROMAN_META || {};
  const resolvedPrintLocations = getResolvedPrintLocations(window.location.pathname);
  const deliveryDaysRaw = meta?.delivery_time ?? meta?.production_time ?? 0;
  
  STATE.tiers = normalizeTiers(meta?.tiers);
  STATE.setupFee = Number(meta?.setup_fee) || 0;
  STATE.productionTime = Math.max(0, parseInt(deliveryDaysRaw, 10) || 0);
  STATE.groupQty = parseInt(meta?.group_quantity) || 1;
  if (!Number.isFinite(STATE.groupQty) || STATE.groupQty < 1) STATE.groupQty = 1;
  STATE.sizeUpchargeMap = normalizeUpcharge(meta?.size_upcharge);

  
  // font-style
  const rawFonts = meta.editor_fonts_schema || "Arial, Verdana, Times New Roman";

  // Only the fonts in Theme settings > Customer text fonts (Jason, 2 Nov 2026:
  // "every font is coming from this box, i don't want any hidden elements"),
  // each name once whatever its capitals. The product template's own Editor
  // Fonts are used only while that box is empty.
  const seenFonts = new Set();
  const boxFonts = (meta.extra_fonts || []).map(f => String(f).trim()).filter(Boolean);
  STATE.editorFonts = (boxFonts.length ? boxFonts : rawFonts.split(','))
    .map(f => String(f).trim())
    .filter(f => f.length > 0 && !seenFonts.has(f.toLowerCase()) && seenFonts.add(f.toLowerCase()));
  const uploadedFonts = (meta.uploaded_fonts || []).map(f => String(f).trim().toLowerCase());

  // size style
  const rawSizes = meta.editor_sizes_schema || "12, 14, 16, 18, 20, 24";
  STATE.editorSizes = rawSizes.split(',').map(s => s.trim()).filter(s => s.length > 0);
  
  

  
  STATE.contactTabText = meta.contact_tab_text || "Artwork is not required to start.";
  STATE.sendAfterMessage = meta.send_after_message || "You can send your artwork after checkout.";
  STATE.artworkFooterText = meta.artwork_footer_text || "Free art proof will be emailed with every order within one business day";
  STATE.sendAfterCheckoutText = meta.send_after_checkout || "Send After Checkout";
  const hidePrintLocation = riMetaBool(meta.hide_print_location, false);
  const hidePrintColors = riMetaBool(meta.hide_print_colors, false);
  const hideUploadImage = riMetaBool(meta.hide_upload_image, false);
  const hideText1 = riMetaBool(meta.hide_text_1, false);
  const hideFont1 = riMetaBool(meta.hide_font_1, false);
  const hideText2 = riMetaBool(meta.hide_text_2, false);
  const hideFont2 = riMetaBool(meta.hide_font_2, false);
  const explicitShowPrintLocation = meta.show_print_location;
  const allowFallbackPrintLocation =
    resolvedPrintLocations.length > 0 &&
    normalizeRiList(window.IMPRINT_LOCATIONS).length === 0;
  // No print location on any product (Jason, 28 Oct 2026). Turning the
  // imprint_locations field off in admin hides it there but keeps the values
  // products already have, and bag handles fell back to Front / Back.
  STATE.showPrintLocation = false;
  STATE.showPrintColor = !hidePrintColors && riMetaBool(meta.show_print_color, normalizeRiList(window.IMPRINT_COLORS).length > 0);
  STATE.showUploadImage = !hideUploadImage && riMetaBool(meta.show_upload_image, true);
  STATE.text1Label = String(meta.text_1_label || "").trim();
  STATE.text2Label = String(meta.text_2_label || "").trim();
  const legacyShowTextFields = riMetaBool(meta.show_text_fields, false);
  const defaultShowText1 = legacyShowTextFields || STATE.text1Label !== "" || !hideText1;
  const defaultShowText2 = legacyShowTextFields || STATE.text2Label !== "" || !hideText2;
  STATE.showText1 = !hideText1 && riMetaBool(meta.show_text_1, defaultShowText1);
  STATE.showFont1 = STATE.showText1 && !hideFont1 && riMetaBool(meta.show_font_1, true);
  STATE.showText2 = !hideText2 && riMetaBool(meta.show_text_2, defaultShowText2);
  STATE.showFont2 = STATE.showText2 && !hideFont2 && riMetaBool(meta.show_font_2, true);
  STATE.showTextFields = STATE.showText1 || STATE.showText2;
  if (STATE.showText1 && !STATE.text1Label) STATE.text1Label = "Text 1";
  if (STATE.showText2 && !STATE.text2Label) STATE.text2Label = "Text 2";

  if (STATE.editorSizes.length === 0) {
    STATE.editorSizes = ["12", "14", "16", "18"];
  }

  // Google Font dynamic loader
  const fontsToLoad = [
    STATE.artworkFontName,
    ...STATE.editorFonts
  ].filter(f => f && !["Arial", "Verdana", "Times New Roman", "Georgia", "Helvetica"].includes(f)
    && !uploadedFonts.includes(String(f).toLowerCase()));

  const uniqueFonts = [...new Set(fontsToLoad)];
  uniqueFonts.forEach(fontName => {
    const linkId = "roman-font-" + fontName.replace(/ /g, "-").toLowerCase();
    if (!document.getElementById(linkId)) {
      const link = document.createElement("link");
      link.id = linkId;
      link.rel = "stylesheet";
      link.href = `https://fonts.googleapis.com/css2?family=${fontName.replace(/ /g, "+")}:wght@400;600;700&display=swap`;
      document.head.appendChild(link);
    }
  });

  console.log("STATE ✅", {
    contact: STATE.contactTabText,
    checkout: STATE.sendAfterCheckoutText,
    fonts: STATE.editorFonts,
    sizes: STATE.editorSizes
  });
}
loadMetaIntoState();

(function injectRomanDeliveryIconCss() {
  const styleId = "roman-delivery-icon-css";
  if (document.getElementById(styleId)) return;

  const style = document.createElement("style");
  style.id = styleId;
  style.textContent = `
    #roman-tier-ui .ri-delivery-line {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
    }

    #roman-tier-ui .ri-delivery-icon {
      border: 0 !important;
      width: auto !important;
      height: auto !important;
      color: #008f8c !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      font-size: 24px !important;
      line-height: 1 !important;
    }

    #roman-tier-ui .ri-delivery-icon i {
      color: #008f8c !important;
      font-size: 24px !important;
      line-height: 1 !important;
    }
  `;

  document.head.appendChild(style);
})();
  function injectRiFontFixStyles() {
    if (document.getElementById("ri-font-fix-styles")) return;

    const style = document.createElement("style");
    style.id = "ri-font-fix-styles";
    style.textContent = `
      .product-details,
      #roman-tier-ui {
        font-family: var(--font-body--family, var(--font-body-family, inherit)) !important;
        font-style: var(--font-body--style, inherit);
      }

      .product-details h1,
      .product-details product-price,
      .product-details .price,
      .product-details .price__container,
      #roman-tier-ui h1,
      #roman-tier-ui h2,
      #roman-tier-ui h3,
      #roman-tier-ui label,
      #roman-tier-ui input,
      #roman-tier-ui button,
      #roman-tier-ui .ri-section-title,
      #roman-tier-ui .ri-head h3,
      #roman-tier-ui .ri-name,
      #roman-tier-ui .ck-radio-label,
      #roman-tier-ui .ck-browse-btn {
        font-family: inherit !important;
      }

      #roman-tier-ui textarea {
        font-family: var(--ri-textarea-font, inherit) !important;
      }

      #roman-tier-ui select:not(.ri-font-select) {
        font-family: inherit !important;
      }

      #roman-tier-ui .ri-font-select {
        font-family: var(--ri-selected-font, var(--font-body--family, var(--font-body-family, inherit))) !important;
      }

      #roman-tier-ui .ri-font-select option {
        font-family: var(--ri-option-font, var(--font-body--family, var(--font-body-family, inherit))) !important;
      }
    `;

    document.head.appendChild(style);
  }

  function escapeRiHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function escapeRiCssFont(value) {
    return String(value || "")
      .replace(/\\/g, "\\\\")
      .replace(/'/g, "\\'");
  }

  function riFontOptionsHtml(includePlaceholder = true) {
    const placeholder = includePlaceholder
      ? `<option value="">-- Select Font --</option>`
      : "";

    const options = (STATE.editorFonts || []).map((font) => {
      const safeValue = escapeRiHtml(font);
      const safeCss = escapeRiCssFont(font);

      return `
        <option
          value="${safeValue}"
          style="font-family:'${safeCss}', var(--font-body--family, sans-serif) !important; --ri-option-font:'${safeCss}', var(--font-body--family, sans-serif);"
        >
          ${safeValue}
        </option>
      `;
    }).join("");

    return placeholder + options;
  }

  function bindRiFontSelects(scope) {
    injectRiFontFixStyles();

    const root = scope || document;

    const applyTextareaFont = (select) => {
      const textFields = select.closest(".ri-text-fields");
      if (!textFields) return;

      const textarea = select.previousElementSibling?.matches("textarea")
        ? select.previousElementSibling
        : null;

      if (!textarea) return;

      if (select.value) {
        const fontValue = `'${escapeRiCssFont(select.value)}', var(--font-body--family, sans-serif)`;
        textarea.style.setProperty("--ri-textarea-font", fontValue);
        textarea.style.setProperty(
          "font-family",
          fontValue,
          "important"
        );
      } else {
        textarea.style.removeProperty("--ri-textarea-font");
        textarea.style.setProperty("font-family", "var(--font-body--family, inherit)", "important");
      }
    };

    root.querySelectorAll(".ri-font-select").forEach((select) => {
      if (select.dataset.riFontBound === "true") return;

      const applyFont = () => {
        const selectedFont = select.value;

        if (selectedFont) {
          const fontValue = `'${escapeRiCssFont(selectedFont)}', var(--font-body--family, sans-serif)`;
          select.style.setProperty("--ri-selected-font", fontValue);
          select.style.setProperty("font-family", fontValue, "important");
        } else {
          select.style.removeProperty("--ri-selected-font");
          select.style.setProperty("font-family", "var(--font-body--family, inherit)", "important");
        }

        applyTextareaFont(select);
      };

      select.dataset.riFontBound = "true";
      applyFont();

      select.addEventListener("change", applyFont);
    });

    root.querySelectorAll(".ri-font-select").forEach(riFontPicker);
  }

  /*
   * The font list drawn by us over the native select, so each name shows in
   * its own font (Jason, 28 Oct 2026). Safari, iPhones and Chrome on a Mac
   * ignore fonts inside a native dropdown's options and showed plain names.
   * The select stays in the page as the source of truth: picking a font sets
   * its value and fires its change event, so the text box, the cart and the
   * proof get the font exactly as before.
   */
  function riFontPicker(select) {
    if (select.dataset.riFontPicker === "true") return;
    select.dataset.riFontPicker = "true";

    const picker = document.createElement("div");
    picker.className = "ri-fontpick";
    const button = document.createElement("button");
    button.type = "button";
    button.className = "ri-fontpick__btn";
    button.setAttribute("aria-haspopup", "listbox");
    button.setAttribute("aria-expanded", "false");
    const list = document.createElement("ul");
    list.className = "ri-fontpick__list";
    list.setAttribute("role", "listbox");
    list.hidden = true;

    const fontCss = (name) => name ? `'${escapeRiCssFont(name)}', var(--font-body--family, sans-serif)` : "";
    const options = Array.from(select.options);

    options.forEach((option) => {
      const item = document.createElement("li");
      item.setAttribute("role", "option");
      item.tabIndex = -1;
      item.dataset.value = option.value;
      item.textContent = option.textContent.trim();
      if (option.value) item.style.fontFamily = fontCss(option.value);
      item.addEventListener("click", () => choose(option.value));
      item.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") { event.preventDefault(); choose(option.value); }
        if (event.key === "ArrowDown") { event.preventDefault(); item.nextElementSibling?.focus(); }
        if (event.key === "ArrowUp") { event.preventDefault(); item.previousElementSibling?.focus(); }
        if (event.key === "Escape") { close(); button.focus(); }
      });
      list.appendChild(item);
    });

    function show() {
      const current = options.find((o) => o.value === select.value) || options[0];
      button.textContent = current ? current.textContent.trim() : "";
      button.style.fontFamily = fontCss(select.value);
      list.querySelectorAll("li").forEach((li) => li.setAttribute("aria-selected", li.dataset.value === select.value ? "true" : "false"));
    }
    function open() {
      list.hidden = false;
      button.setAttribute("aria-expanded", "true");
      (list.querySelector('[aria-selected="true"]') || list.firstElementChild)?.focus();
    }
    function close() {
      list.hidden = true;
      button.setAttribute("aria-expanded", "false");
    }
    function choose(value) {
      select.value = value;
      select.dispatchEvent(new Event("change", { bubbles: true }));
      show();
      close();
      button.focus();
    }

    button.addEventListener("click", () => (list.hidden ? open() : close()));
    button.addEventListener("keydown", (event) => {
      if (event.key === "ArrowDown") { event.preventDefault(); open(); }
    });
    document.addEventListener("click", (event) => {
      if (!picker.contains(event.target)) close();
    });
    select.addEventListener("change", show);

    select.classList.add("ri-fontpick__native");
    select.tabIndex = -1;
    select.setAttribute("aria-hidden", "true");
    select.after(picker);
    picker.append(button, list);
    show();
  }

  injectRiFontFixStyles();

  function roundUpToIncrement(val, inc) {
    if (inc <= 1) return val;
    return Math.ceil(val / inc) * inc;
  }

 function normalizeImg(u) {
  if (!u) return "";
  // remove query + common size parts to match thumbnails
  const base = String(u).split("?")[0];
  return base.replace(/_(\d+x\d+|small|medium|large|grande)\./, ".").toLowerCase();
}

// Filename (no path, no query, no extension) for matching a colour image to a
// gallery slide. featured_image.src and the slide markup can live on DIFFERENT
// CDN hosts (cdn.shopify.com vs the store domain), so a full-URL compare fails —
// the basename is the stable key. Also tolerates a variant hash suffix
// (Antique_Irish_Green vs Antique_Irish_Green_<hash>) via the includes() below.
function riImageBaseName(u) {
  const clean = normalizeImg(u).split('/').pop() || '';
  return clean.replace(/\.[a-z0-9]+$/i, '');
}

// A colour picked on a category page arrives as ?variant=. The gallery and the
// hidden variant input already follow it, but the Product Color carousel showed
// "Select color", so select that colour there too and scroll the carousel (not
// the page) to it. Cart edits (?edit=) are left to prefillFromURL.
function riPreselectColorFromUrl(wrapper, product, colorIndex) {
  const params = new URLSearchParams(window.location.search);
  const id = params.get('variant');
  if (!id || params.get('edit')) return;

  const variant = (product.variants || []).find((v) => String(v.id) === id);
  const options = variant ? variant.options || [variant.option1, variant.option2, variant.option3] : [];
  const color = options[colorIndex];
  const item = Array.from(wrapper.querySelectorAll('.ri-item')).find((i) => i.dataset.color === color);
  if (!item) return;

  item.click();
  requestAnimationFrame(() => {
    const track = item.closest('.ri-track');
    if (!track) return;
    const t = track.getBoundingClientRect();
    const r = item.getBoundingClientRect();
    track.scrollLeft += r.left - t.left - (t.width - r.width) / 2;
  });
}

// On a phone the product photo is far above the colour carousel, so after a
// colour is tapped the page glides up to the photo, under the sticky header,
// to show that colour. Nothing moves on larger screens, where the photo sits
// beside the options, or when the photo is already on screen.
//
// Measured from the grid, not the gallery: on phones the gallery is sticky
// behind the details, so its own position says "on screen" when it is not.
function riShowGalleryOnMobile() {
  if (!window.matchMedia('(max-width: 749px)').matches) return;
  const media = document.querySelector('.product-information__media');
  if (!media) return;
  const anchor = media.closest('.product-information__grid') || media;
  const header = document.querySelector('.header-section');
  const headerHeight = header ? header.getBoundingClientRect().height : 0;
  const top = Math.max(0, anchor.getBoundingClientRect().top + window.scrollY - headerHeight);
  if (window.scrollY <= top + 40) return;
  window.scrollTo({ top, behavior: 'smooth' });
}

function setMainProductImage(src) {
  if (!src) return;

  const target = normalizeImg(src);

  // ✅ A0) Swiper gallery (this theme): the slides ALREADY hold every colour's
  //    image, so navigate to the matching slide rather than overwriting the active
  //    <img>. The old overwrite set img.src + cleared srcset on the visible slide,
  //    which reloaded it out from under Swiper and desynced its height measurement —
  //    that is why the gallery sometimes jumped and the image "went up". Native
  //    navigation keeps Swiper's layout intact.
  const swiperEl = Array.from(document.querySelectorAll('.swiper'))
    .find((el) => el.swiper && el.querySelector('.swiper-slide img'));
  if (swiperEl && swiperEl.swiper) {
    const targetBase = riImageBaseName(src);
    const slides = Array.from(swiperEl.querySelectorAll('.swiper-slide'));
    let domIndex = -1;
    let loopIndex = -1;
    // The same file first, a partial name match only if there is none: the
    // group photo "nolan-...-30-oz" is the start of "nolan-...-30-oz-black-...",
    // so the loose match alone sent every colour to the group photo.
    const same = (base) => base === targetBase;
    const near = (base) => base.includes(targetBase) || targetBase.includes(base);
    [same, near].forEach((test) => {
      slides.forEach((slide, i) => {
        if (domIndex !== -1) return;
        const img = slide.querySelector('img');
        const base = img ? riImageBaseName(img.getAttribute('src') || img.src) : '';
        if (base && targetBase && test(base)) {
          domIndex = i;
          const di = slide.getAttribute('data-swiper-slide-index');
          loopIndex = di == null ? i : Number(di);
        }
      });
    });
    if (domIndex !== -1) {
      try {
        const sw = swiperEl.swiper;
        if (sw.params && sw.params.loop && typeof sw.slideToLoop === 'function') sw.slideToLoop(loopIndex);
        else sw.slideTo(domIndex);
      } catch (e) {}
      return; // handled natively — never overwrite the slide image
    }
  }

  // ✅ A) Ella theme: try clicking matching thumbnail (best)
  const thumbSelectors = [
    ".productView-nav img",
    ".productView-thumbnail img",
    ".productView-thumbnails img",
    ".slick-dots img",
  ];

  for (const sel of thumbSelectors) {
    const thumbs = Array.from(document.querySelectorAll(sel));
    const match = thumbs.find((img) => normalizeImg(img.src).includes(target) || target.includes(normalizeImg(img.src)));
    if (match) {
      // click the thumbnail / its parent button/link/slide
      (match.closest("button,a,.slick-slide,li,div") || match).click();
      return;
    }
  }

  // ✅ B) Fallback: update currently visible/main images
  const mainSelectors = [
    ".productView-image img",
    ".product__media img",
    ".product-single__media img",
    "[data-product-featured-media] img",
    ".product__photo img",
    ".slick-current img",
    ".swiper-slide-active img",
  ];

  mainSelectors.forEach((sel) => {
    const img = document.querySelector(sel);
    if (img) {
      img.src = src;
      img.srcset = "";
      img.loading = "eager";
    }
  });

  // ✅ C) Extra: if slick exists, refresh (helps Ella sometimes)
  if (window.jQuery) {
    const $ = window.jQuery;
    const $slider = $(".productView-image");
    if ($slider.length && $slider.hasClass("slick-initialized")) {
      try { $slider.slick("setPosition"); } catch (e) {}
    }
  }
}
  function findATCButton() {
    return (
      document.querySelector('form[action*="/cart/add"] button[type="submit"]') ||
      document.querySelector('button[name="add"]')
    );
  }

  function syncProductFormQuantity(qty) {
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    let input = form.querySelector('input[name="quantity"]');
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = "quantity";
      form.appendChild(input);
    }

    input.value = String(qty || 0);
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function ensureSetsNoteNearATC() {
    const btn = findATCButton();
    if (!btn) return;

    if (document.getElementById("ri-sets-note")) return;

    // ✅ If X > 1: show "(sets of X)" next to Add to Cart
    if (STATE.groupQty > 1) {
      const note = document.createElement("span");
      note.id = "ri-sets-note";
      note.textContent = `(sets of ${STATE.groupQty})`;
      note.style.marginRight = "10px";
      note.style.fontSize = "14px";
      note.style.fontWeight = "600";
      
      


      btn.parentNode.insertBefore(note, btn);
    }
  }




  
  // ✅ Size key normalization (trim/case tolerant)
  function getSizeUpcharge(size) {
    const key = String(size || "").trim();
    if (!key) return 0;

    const keyUpper = key.toUpperCase();

    // exact match
    let raw = STATE.sizeUpchargeMap?.[key];
    if (raw == null) raw = STATE.sizeUpchargeMap?.[keyUpper];

    // tolerant match by normalized keys
    if (raw == null && STATE.sizeUpchargeMap && typeof STATE.sizeUpchargeMap === "object") {
      for (const k in STATE.sizeUpchargeMap) {
        if (String(k).trim().toUpperCase() === keyUpper) {
          raw = STATE.sizeUpchargeMap[k];
          break;
        }
      }
    }

    const n = Number(raw);
    return Number.isFinite(n) ? n : 0;
  }

  // Whether the product's own size_upcharge chart lists this size at all.
  // A listed 0 means "no upcharge" (S&S products list every size), so the
  // apparel default below must not add XL +0.20 / 2XL +0.25 on top of it.
  function hasSizeUpcharge(size) {
    const map = STATE.sizeUpchargeMap;
    if (!map || typeof map !== "object") return false;
    const keyUpper = String(size || "").trim().toUpperCase();
    if (!keyUpper) return false;
    for (const k in map) {
      if (String(k).trim().toUpperCase() === keyUpper && map[k] !== "" && map[k] != null) return true;
    }
    return false;
  }

  // Resolve a size's upcharge the SAME way the product page's size grid does:
  // metafield first, then a "+$x" embedded in the size name, then the apparel
  // default (XL +0.20, XXL +0.25). This USED to live only inside
  // getSimpleSizeUpchargeAmount, a closure within buildSimpleQuantityUI — invisible
  // to connectCartButton. So the add-to-cart save fell back to metafield-only and
  // persisted NO upcharge for any product relying on the name/default path, leaving
  // the cart's size line reading "XL: 6" instead of "XL: 6 (+$0.20)". Hoisted here so
  // display and save agree.
  function riSizeUpcharge(size) {
    const fromMeta = getSizeUpcharge(size);
    if (fromMeta > 0) return fromMeta;
    if (hasSizeUpcharge(size)) return 0;

    const fromName = String(size || "").match(/\+\$?([\d.]+)/);
    if (fromName) return Number(fromName[1]) || 0;

    const normalized = String(size || "").replace(/\s*\+\$?.*$/i, "").trim().toLowerCase();
    if (normalized === "xl") return 0.20;
    if (["xxl", "2xl", "2x"].includes(normalized)) return 0.25;
    return 0;
  }

  // -----------------------------
  // 2) Pricing + Group Increment Enforcement (total qty)

  //    ✅ upcharge comes from metafield JSON
  // -----------------------------
  function updateTotals(wrapper, applyCorrection = true) {
    const inputs = Array.from(wrapper.querySelectorAll("#ri-size-grid input"));
    let total = inputs.reduce((sum, i) => {
      const value = Math.max(0, parseInt(i.value || 0, 10) || 0);
      if (String(i.value) !== String(value)) i.value = String(value);
      return sum + value;
    }, 0);

    // ✅ Force total quantity in increments of X (only when applyCorrection = true)
    if (applyCorrection && STATE.groupQty > 1 && total > 0 && total % STATE.groupQty !== 0) {
      const corrected = roundUpToIncrement(total, STATE.groupQty);
      const needed = corrected - total;

      const target =
        STATE.activeQtyInput ||
        inputs.filter((i) => Number(i.value) > 0).pop() ||
        inputs[0];

      if (target) target.value = Number(target.value || 0) + needed;
      total = corrected;

    const totalQtyEl = wrapper.querySelector("#ri-total-qty");
    if (totalQtyEl) totalQtyEl.style.color = "red";
    } else {
      const totalQtyEl = wrapper.querySelector("#ri-total-qty");
      if (totalQtyEl) totalQtyEl.style.color = "inherit";
    }

    const currentTier =
      STATE.tiers.slice().filter((x) => total >= x.min).pop() || STATE.tiers[0];


      // first page deisgn to total price + shipping
      









    // ✅ subtotal = Σ(qty[size] * (tier.sale_price + upcharge[size]))
    let subtotal = 0;
    let focusedUnitPrice = 0;

    inputs.forEach((input) => {
      const qty = Math.max(0, parseInt(input.value || 0, 10) || 0);
      if (!qty) return;

      const size = input.dataset.size;
      const sizeExtra = getSizeUpcharge(size);

      const unitPrice = (currentTier?.sale_price || 0) + sizeExtra;
      subtotal += qty * unitPrice;

      if (STATE.activeQtyInput === input) focusedUnitPrice = unitPrice;
    });

    if (!focusedUnitPrice) focusedUnitPrice = currentTier?.sale_price || 0;

    // ✅ Grand total: add setup fee only when total > 0
    const grandTotal = total > 0 ? (subtotal + STATE.setupFee) : 0;
    STATE.subtotal = subtotal;
    STATE.totalQty = total;
    STATE.unitPrice = focusedUnitPrice;
     STATE.grandTotal = grandTotal;

    // UI update
    const totalQtyEl = wrapper.querySelector("#ri-total-qty");
    const eachPriceEl = wrapper.querySelector("#ri-each-price");
    const subtotalEl = wrapper.querySelector("#ri-subtotal");
    const grandTotalEl = wrapper.querySelector("#ri-grand-total");
    const setupEls = wrapper.querySelectorAll("#ri-setup, #ri-setup-fee");

    if (totalQtyEl) totalQtyEl.textContent = String(total);
    if (eachPriceEl) eachPriceEl.textContent = money(focusedUnitPrice);
    if (subtotalEl) subtotalEl.textContent = money(subtotal);
    if (grandTotalEl) grandTotalEl.textContent = money(grandTotal);
    setupEls.forEach((el) => {
      el.textContent = money(STATE.setupFee);
    });

    syncProductFormQuantity(total);
    updateFirstPageTotal();
    updateCustomizationSummary(); 
    // updateSetsNoteByTotal(total);

    // Tier table (active size context extra)
    const activeSize = STATE.activeQtyInput?.dataset?.size || null;
    const activeExtra = activeSize ? getSizeUpcharge(activeSize) : 0;

    wrapper.querySelectorAll(".ri-reg-price-cell").forEach((td, idx) => {
      const tier = STATE.tiers[idx];
      if (!tier) return;
      td.innerHTML = `<strike>${money(tier.price + activeExtra)}</strike>`;
    });

    wrapper.querySelectorAll(".ri-sale").forEach((td, idx) => {
      const tier = STATE.tiers[idx];
      if (!tier) return;
      td.innerHTML = `<b>${money(tier.sale_price + activeExtra)}</b>`;
    });
  }
  function fillTierTableBase(wrapper) {
  if (!wrapper) return;

  // Reg (strike)
  wrapper.querySelectorAll(".ri-reg-price-cell").forEach((td, idx) => {
    const tier = STATE.tiers[idx];
    if (!tier) return;
    td.innerHTML = `<strike>${money(tier.price)}</strike>`;
  });

  // Sale (bold)
  wrapper.querySelectorAll(".ri-sale").forEach((td, idx) => {
    const tier = STATE.tiers[idx];
    if (!tier) return;
    td.innerHTML = `<b>${money(tier.sale_price)}</b>`;
  });
}
  
  // -----------------------------
  // 3) UI build (DESIGN UNCHANGED)
  // -----------------------------
  function buildUI(colorItems) {
    const meta = window.ROMAN_META || {};
    const fonts = meta.editor_fonts ? meta.editor_fonts.split(',').map(f => f.trim()) : ["Arial", "Helvetica"];
    const sizes = meta.editor_sizes ? meta.editor_sizes.split(',').map(s => s.trim()) : ["12", "14", "16"];
    const contactText = meta.contact_tab_text || "Artwork is not required";
    const checkoutText = meta.send_after_checkout || "Send After Checkout";
    loadMetaIntoState();
    const locations = getResolvedPrintLocations(window.location.pathname);
    const hasPrintLocationField = STATE.showPrintLocation && locations.length > 0;
    const hasPrintColorField = STATE.showPrintColor && normalizeRiList(window.IMPRINT_COLORS).length > 0;
    let locationOptions = '<option value="" disabled selected>Choose Location...</option>';
    locations.forEach(function(loc){
      locationOptions += `<option value="${escapeRiHtml(loc)}">${escapeRiHtml(loc)}</option>`;
    });
    const showCustomizationStep = hasPrintLocationField || hasPrintColorField;
    const showTextFields = STATE.showTextFields;
    const showImageTab = STATE.showUploadImage;
    const showCombinedTab = STATE.showUploadImage && STATE.showText2;
    const showArtworkMethodControls = STATE.showUploadImage;
    const showTextTab = STATE.showText1;
    const useTextAsDefaultTab = !showImageTab && showTextTab;
    const useContactAsDefaultTab = !showImageTab && !showTextTab;
    const btn = findATCButton();
    if (!btn) return null;

    document.getElementById("roman-tier-ui")?.remove();

    ensureSetsNoteNearATC();

    const wrapper = document.createElement("div");
    wrapper.id = "roman-tier-ui";
    if (!showArtworkMethodControls) {
      wrapper.classList.add("ri-no-upload-artwork");
    }


    

    wrapper.innerHTML = `


   
    
  <div class="ri-panel">
        <section class="ri-card">
          <header class="ri-head"><h3>Select a Color:</h3></header>
          <div class="ri-body">
            <div class="ri-carousel">
              <button class="ri-arrow ri-prev" type="button">‹</button>
              <div class="ri-track" role="list"></div>
              <button class="ri-arrow ri-next" type="button">›</button>
            </div>
            <div class="ri-note">Product Color: <b id="ri-color-name">Select color</b></div>
          </div>
        </section>

        <section class="ri-card">
          <header class="ri-head"><h3>Quantity & Pricing:</h3></header>
          <div class="ri-body">
            <div class="ri-table-wrap">
              <table class="ri-qty-table">
                <thead><tr><th>Quantity</th>${STATE.tiers.map(t => `<th>${t.min}+</th>`).join("")}</tr></thead>
                <tbody>
                  <tr><td>Price</td>${STATE.tiers.map(() => `<td class="ri-reg-price-cell"></td>`).join("")}</tr>
                  <tr><td>as low as</td>${STATE.tiers.map(t => `<td class="ri-sale"><b>${money(t.sale_price)}</b></td>`).join("")}</tr>
                </tbody>
              </table>
            </div>

            <div class="ri-size-wrap" id="ri-size-wrap" style="display:none;">
              <div class="ri-size-title">Enter Quantity for Each Size:</div>
              <div class="ri-size-grid" id="ri-size-grid"></div>

              <div class="ri-summary">
                <div>Total: <b id="ri-total-qty">0</b> | Grand Total: <b id="ri-grand-total">$0.00</b></div>
                <div style="font-size:0.8em; margin-top:5px;">Price Each: <span id="ri-each-price">$0.00</span> | setup_free: <span id="ri-setup">$10.00</span> | Subtotal: <span id="ri-subtotal">$0.00</span></div>
              </div>
            </div>
            

          </div>
        </section>



  </div>
  
  

    



  

 <div>
    


 </div>


<div id="ri-customization-step" style="${showCustomizationStep ? 'display: block;' : 'display: none;'} padding: 25px; border: 1px solid #000; margin-top: 5px; background: #fff;">
	  
	  <h2 style="${hasPrintLocationField ? '' : 'display:none;'}font-size: 20px; border-bottom: 2px solid #000; padding-bottom: 10px; margin-bottom: 20px; text-transform: uppercase;">Print Location</h2>
	
        <select id="ri-location-select" style="${hasPrintLocationField ? '' : 'display:none;'}width:100%; padding:12px; border:1px solid #ccc; border-radius:0; margin-bottom: 20px;">
            ${locationOptions}

        </select>
    <div style="${hasPrintColorField ? '' : 'display:none;'}margin-bottom:25px;">
    <label style="display:block;font-weight:bold;margin-bottom:8px;">Select Print Color</label>
    
    <div class="ri-color-dropdown-wrapper" style="border: 1px solid #ccc; position: relative; font-family: inherit;">
        <div id="ri-dropdown-header" style="padding: 10px; cursor: pointer; background: #fff; display: flex; justify-content: space-between; align-items: center;">
            <div style="display: flex; align-items: center; gap: 10px;">
                <div id="ri-selected-placeholder-palette" style="width: 25px; height: 15px; background: transparent; border-radius: 4px; border: 1px solid rgba(0,0,0,0.1);"></div>
                <span id="ri-selected-placeholder-text">-- Select Print Color --</span>
            </div>
            <span>▼</span>
        </div>

        <div id="ri-swatch-container" style="display:none; max-height: 300px; overflow-y: auto; background: #eee; border-top: 1px solid #ccc;">
            <div style="padding: 10px; font-weight: bold; background: #ddd;">Available Print Colors</div>
            </div>
    </div>

</div>



 






 <div class="artwork-wrapper">

    <div class="artwork-top">
      <div class="artwork-title">
         <span class="help"></span> 
      </div>

      <div class="artwork-choice">
        <label>
          <input type="radio" name="artwork_time" checked>
         
        </label>

        <label>
          <input type="radio" name="artwork_time">
        
        </label>
      </div>
   </div>


   <div class="ck-artwork-container">
    <div class="ck-header">
     <div class="ck-header-left">
      Add Your Artwork <span class="info-icon">?</span>
    </div>
    ${showArtworkMethodControls ? `
     <div class="ck-header-right">
      <label class="ck-radio-label ck-upload-radio">
        <input type="radio" name="properties[Artwork Method]" value="Add Now" checked onclick="ckToggleMain(true)">
        <span class="ck-radio-circle"></span>
        <span class="ck-radio-main">Upload Image</span>
      </label>
      <label class="ck-radio-label">
        <input type="radio" name="properties[Artwork Method]" value="Send After Checkout" onclick="ckToggleMain(false)">
        <span class="ck-radio-circle"></span>
        <span>
          <span class="ck-radio-main">Send Image After Submitting Order</span>
        </span>
      </label>
      <!-- Lives beside the radio it describes so it lands under it at every
           width. Parked at the end of .ck-body it fell below the text fields. -->
      <div id="ck-panel-sendafter" class="ck-panel">
        <p style="font-size: 13px;">${STATE.sendAfterMessage}</p>
      </div>
    </div>
    ` : ''}
   </div>
 
   <div class="ck-body">
    <div id="ck-tabs-nav" class="ck-tabs">
      ${showImageTab ? `
      <div class="ck-tab-item active" onclick="ckSwitchTab('image', this)">
        <div class="ck-icon">☆</div><div class="ck-label">Only Image</div>
      </div>
      ` : ''}
      ${showTextTab ? `
      <div class="ck-tab-item${useTextAsDefaultTab ? ' active' : ''}" onclick="ckSwitchTab('text', this)">
        <div class="ck-icon">Aa</div><div class="ck-label">Only Text</div>
      </div>
      ` : ''}
      ${showCombinedTab ? `
      <div class="ck-tab-item" onclick="ckSwitchTab('both', this)">
        <div class="ck-icon">Aa☆</div><div class="ck-label">Text/Image</div>
      </div>
      ` : ''}
     
      <div class="ck-tab-item${useContactAsDefaultTab ? ' active' : ''}" onclick="ckSwitchTab('contact', this)">
        <div class="ck-icon">👤</div><div class="ck-label">Contact Us</div>
      </div>
    </div>

    
 
    <div id="ck-content-area">




     
                ${showImageTab ? `
                <div id="ck-panel-image" class="ck-panel active">
                  <div class="ck-file-input">
          <input type="text" id="file-name-1" placeholder="Choose file" readonly>
          <label class="ck-browse-btn">
            Choose File
            <input type="file" id="artwork-file-1" name="properties[Artwork Image]" accept="image/*" onchange="handleDynamicPreview(this, '1')">
          </label>
        </div>
        <div class="ck-file-formats">Accepted File Formats: jpeg, png, pdf, svg, ai</div>

        <div id="preview-container-1" style="display:none; margin-top: 15px;">
          <div style="position: relative; width: 150px; height: 150px;">
            <img id="image-preview-snapshot-1" src="" style="width: 150px; height: 150px; object-fit: cover; border: 1px solid #ddd; border-radius: 4px;">
            <span onclick="clearDynamicImage('1')" style="position: absolute; top: -10px; right: -10px; background: red; color: white; width: 22px; height: 22px; border-radius: 50%; text-align: center; cursor: pointer; line-height: 20px; font-weight: bold;">×</span>
          </div>
          <div style="margin-top: 10px;">
            <button type="button" onclick="saveDynamicImage('1')" style="background: #000; color: #fff; padding: 5px 15px; cursor: pointer; border: none;">Save Image</button>
          </div>
        </div>
        </div>
        ` : ''}



 
      ${showTextTab ? `
      <div id="ck-panel-text" class="ck-panel${useTextAsDefaultTab ? ' active' : ''}">
        <div class="ck-rich-editor">
          <div class="ck-toolbar">
                ${STATE.showFont1 ? `
                <select class="ri-font-select" onchange="formatDoc('fontName', this.value)" style="font-family: inherit;">
                  ${riFontOptionsHtml(false)}
                </select>
                ` : ''}
                <select onchange="formatDoc('fontSize', this.value)">
                ${STATE.editorSizes.map(s => `<option value="${s}">${s}px</option>`).join('')}
              </select>
            <button type="button" onclick="formatDoc('bold')"><b>B</b></button>
            <button type="button" onclick="formatDoc('italic')"><b><i>I</i></b></button>
            <span class="ck-sep"></span>
            <button type="button" onclick="formatDoc('justifyLeft')"><i class="fa-solid fa-align-left"></i></button>
            <button type="button" onclick="formatDoc('justifyCenter')"><i class="fa-solid fa-align-center"></i></button>
            <button type="button" onclick="formatDoc('justifyRight')"><i class="fa-solid fa-align-right"></i></button>
          </div>
          <div id="editor-only-text" class="ck-text-box" contenteditable="true" oninput="syncText('editor-only-text', 'hidden-only-text')"></div>
          <input type="hidden" name="properties[Custom Text]" id="hidden-only-text">
        </div>
      </div>
      ` : ''}
 
      ${showCombinedTab ? `
      <div id="ck-panel-both" class="ck-panel">
        <div class="ck-rich-editor" style="margin-bottom: 15px;">
          <div class="ck-toolbar">
                ${STATE.showFont2 ? `
                <select class="ri-font-select" onchange="formatDoc('fontName', this.value)" style="font-family: inherit;">
                  ${riFontOptionsHtml(false)}
                </select>
                ` : ''}
              <select onchange="formatDoc('fontSize', this.value)">
                ${STATE.editorSizes.map(s => `<option value="${s}">${s}px</option>`).join('')}
              </select>
            <button type="button" onclick="formatDoc('bold')"><b>B</b></button>
            <button type="button" onclick="formatDoc('italic')"><b><i>I</i></b></button>
            <span class="ck-sep"></span>
            <button type="button" onclick="formatDoc('justifyLeft')"><i class="fa-solid fa-align-left"></i></button>
            <button type="button" onclick="formatDoc('justifyCenter')"><i class="fa-solid fa-align-center"></i></button>
            <button type="button" onclick="formatDoc('justifyRight')"><i class="fa-solid fa-align-right"></i></button>
          </div>
          <div id="editor-both" class="ck-text-box" contenteditable="true" style="min-height: 80px;" oninput="syncText('editor-both', 'hidden-both-text')"></div>
          <input type="hidden" name="properties[Custom Text (Combined)]" id="hidden-both-text">
        </div>


      <div class="ck-file-input">
        <input type="text" id="file-name-2" placeholder="Choose file" readonly>
        <label class="ck-browse-btn">
          Browse
          <input type="file" id="artwork-file-2" name="properties[Artwork Image (Combined)]" accept="image/*" onchange="handleDynamicPreview(this, '2')">
        </label>
      </div>

      <div id="preview-container-2" style="display:none; margin-top: 15px;">
        <div style="position: relative; width: 150px; height: 150px;">
          <img id="image-preview-snapshot-2" src="" style="width: 150px; height: 150px; object-fit: cover; border: 1px solid #ddd; border-radius: 4px;">
          <span onclick="clearDynamicImage('2')" style="position: absolute; top: -10px; right: -10px; background: red; color: white; width: 22px; height: 22px; border-radius: 50%; text-align: center; cursor: pointer; line-height: 20px; font-weight: bold;">×</span>
        </div>
        <div style="margin-top: 10px;">
          <button type="button" onclick="saveDynamicImage('2')" style="background: #000; color: #fff; padding: 5px 15px; cursor: pointer; border: none;">Save Image</button>
        </div>
      </div>



      </div>
      ` : ''}
 
      
      <div id="ck-panel-contact" class="ck-panel${useContactAsDefaultTab ? ' active' : ''}">
              <p style="font-size: 13px;">${window.contactTabText}</p>
            </div>
          </div>

 
    </div>
</div>
  








<div id="ri-order-summary" style="border:1px solid #eee;padding:18px;margin-bottom:20px;background:#fafafa">

    <div style="background:#222;color:#fff;padding:12px 15px;font-weight:bold;font-size:18px;display:flex;justify-content:space-between">
    <span>Total</span>
    <span id="ri-final-total">$0.00</span>
    </div>

    <div style="padding:12px 5px;font-size:14px">

    <div style="display:flex;justify-content:space-between;margin-bottom:6px">
    <span id="ri-qty-line">0 qty x $0.00</span>
    <span id="ri-subtotal-show">$0.00</span>
    </div>

    <div style="display:flex;justify-content:space-between;margin-bottom:6px">
    <span>Setup fee:</span>
    <span id="ri-setup-show">$0.00</span>
    </div>

    <div id="delivery-timeframe-display" style="margin-top: 15px; padding: 10px; border-radius: 5px; background-color: #f9f9f9; border: 1px dashed #d9534f; display: inline-block;">
      <p style="margin: 0; font-size: 14px; color: #333;">
        <strong style="color: #d9534f;">🚚 Est. Delivery:</strong> 
        <span id="dynamic-delivery-date" style="font-weight: 700;">Calculating...</span>
      </p>
    </div>

    

    

  </div>

  
  

  <div class="custom-atc-wrapper" style="margin-top: 20px;">
    <button type="button" id="trigger-real-atc" 
            style="width:100%; background:#28a745; color:#fff; padding:18px; border:none; font-size:18px; font-weight:bold; cursor:pointer; border-radius: 5px;">
      ADD TO CART
    </button>
 </div>




    `;
const form = btn.closest("form");
form.parentNode.insertBefore(wrapper, form);

renderImprintColors(); 
updateCustomizationSummary();
updateDeliveryDate();


setTimeout(() => {
  fillTierTableBase(wrapper);
  updateDeliveryDate();
  bindRiFontSelects(wrapper);
}, 0);

setTimeout(() => bindRiFontSelects(wrapper), 300);

return wrapper;
  }
  

  function renderSizes(wrapper, product, color) {
    const sizeWrap = wrapper.querySelector("#ri-size-wrap");
    const grid = wrapper.querySelector("#ri-size-grid");
    const displaySizeName = (size) => {
      const clean = String(size || "").replace(/\s*\+\$.*$/i, "").trim();
      const key = clean.toLowerCase();
      const labels = {
        s: "Small",
        small: "Small",
        m: "Medium",
        medium: "Medium",
        l: "Large",
        large: "Large",
        xl: "XL",
        xxl: "XXL",
        "2xl": "XXL",
        "2x": "XXL"
      };
      return labels[key] || clean;
    };
    const sizeRank = (size) => {
      const key = displaySizeName(size).toLowerCase();
      return { small: 1, medium: 2, large: 3, xl: 4, xxl: 5 }[key] || 99;
    };
    const displayUpcharge = (size) => {
      const fromMeta = getSizeUpcharge(size);
      if (fromMeta > 0) return `+$${fromMeta.toFixed(2)}`;
      const fromName = String(size || "").match(/\+\$[\d.]+/)?.[0];
      return fromName || "";
    };

    const variants = product.variants.filter(
      (v) => (v.options || [v.option1])[STATE.colorIndex] === color
    );

    STATE.variantsBySize = {};
    variants.forEach((v) => {
      const opts = v.options || [v.option1, v.option2, v.option3];
      const size = opts[STATE.sizeIndex];
      if (size) STATE.variantsBySize[size] = v;
    });

    const sizes = [
      ...new Set(
        variants.map((v) => (v.options || [v.option1, v.option2])[STATE.sizeIndex])
      ),
    ].filter(Boolean).sort((a, b) => sizeRank(a) - sizeRank(b));

    grid.innerHTML = sizes
      .map(
        (s) => `
          <label class="ri-size">
            <span>${displaySizeName(s)}</span>
            <input type="number" min="0" value="0" data-size="${s}">
            ${displayUpcharge(s) ? `<small>${displayUpcharge(s)}</small>` : ""}
          </label>
        `
      )
      .join("");

    // ✅ Debounce correction so user can type 2 / 12 etc.
    let typingTimer = null;

    grid.querySelectorAll("input").forEach((i) => {
      i.addEventListener("focus", () => {
        STATE.activeQtyInput = i;
      });

      i.addEventListener("input", () => {
        STATE.activeQtyInput = i;
        updateTotals(wrapper, false);

        clearTimeout(typingTimer);
        typingTimer = setTimeout(() => {
          updateTotals(wrapper, true);
        }, 1800);
      });

      i.addEventListener("change", () => {
        STATE.activeQtyInput = i;
        updateTotals(wrapper, true);
      });

      i.addEventListener("blur", () => {
        STATE.activeQtyInput = i;
        updateTotals(wrapper, true);
      });
    });

    const inputs = Array.from(grid.querySelectorAll("input"));
    if (inputs.length && inputs.every((input) => Number(input.value || 0) === 0)) {
      inputs[0].value = String(Number(STATE.tiers?.[0]?.min || 1));
      STATE.activeQtyInput = inputs[0];
    }

    sizeWrap.style.setProperty("display", "block", "important");
    updateTotals(wrapper, true);
  }

  function mountCarousel(wrapper, colorItems, product) {
    const track = wrapper.querySelector(".ri-track");
    track.innerHTML = colorItems
      .map(
        (item) => `
        <div class="ri-item" data-color="${item.color}" style="cursor:pointer;">
          <img class="ri-thumb" src="${item.img}" alt="${item.color}">
          <div class="ri-name">${item.color}</div>
        </div>
      `
      )
      .join("");

    wrapper.querySelectorAll(".ri-item").forEach((item) => {
      item.addEventListener("click", function () {
        const color = this.dataset.color;

        wrapper.querySelectorAll(".ri-item").forEach((i) => i.classList.remove("is-active"));
        this.classList.add("is-active");
        wrapper.querySelector("#ri-color-name").textContent = color;

        STATE.selectedColor = color;

        STATE.selectedVariant = product.variants.find(
          (v) => (v.options || [v.option1])[STATE.colorIndex] === color
        );

        if (STATE.selectedVariant) {
          setMainProductImage(
            STATE.selectedVariant.featured_image?.src || STATE.selectedVariant.image
          );
          forceSelectVariantById(STATE.selectedVariant.id);
          renderSizes(wrapper, product, color);
        }
      });
    });

    wrapper.querySelector(".ri-prev").onclick = () =>
      track.scrollBy({ left: -240, behavior: "smooth" });
    wrapper.querySelector(".ri-next").onclick = () =>
      track.scrollBy({ left: 240, behavior: "smooth" });
  }

function updateSetsNoteByTotal(total) {
  const note = document.getElementById("ri-sets-note");
  if (!note) return;

  // groupQty <= 1 , note not needed
  if (STATE.groupQty <= 1) {
    note.remove();
    return;
  }

  // ✅ corrected total = X
  const x = total > 0 ? total : STATE.groupQty;

  // ✅ show sets of X (dynamic)
  // note.textContent = `(sets of ${x})`;
}

  // -----------------------------
  // 4) Shopify product JSON helpers
  // -----------------------------
  async function getProductData() {
    const handle = window.location.pathname.match(/\/products\/([^\/]+)/)?.[1];
    // main-product.liquid writes the product into the page (drafts have no .js),
    // so it is used as it is rather than downloaded a second time.
    if (window.RI_PRODUCT_JSON) return window.RI_PRODUCT_JSON;
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (res.ok) return await res.json();
    } catch (e) {}
    if (window.RI_PRODUCT_JSON) return window.RI_PRODUCT_JSON;
    throw new Error("ROMAN: product data unavailable");
  }

  // Sizes per colour from the product's Sizes By Color field, for products
  // with one variant per colour (many colours x sizes would pass Shopify's
  // 250 variants, and only the first 250 reach the page). null when unset.
  function riSizesByColor() {
    let v = window.ROMAN_META?.sizes_by_color;
    if (typeof v === "string") {
      try { v = v ? JSON.parse(v) : null; } catch (e) { v = null; }
    }
    return v && typeof v === "object" && Object.keys(v).length ? v : null;
  }

  function detectOptionIndexes(product) {
    const names = (product.options || []).map((o) => (o.name || o).toLowerCase());
    const colorIndex = names.findIndex((n) => n.includes("color") || n.includes("colour"));
    const sizeIndex = names.findIndex((n) => n.includes("size"));
    const hasColor = colorIndex !== -1;
    const hasSize = sizeIndex !== -1 || !!riSizesByColor();
    const type = hasColor && hasSize ? "apparel" : hasColor ? "color-only" : "default";

    return { colorIndex, sizeIndex, hasColor, hasSize, type };
  }

  function getCurrentProductHandle(product) {
    return String(product?.handle || window.location.pathname.match(/\/products\/([^\/]+)/)?.[1] || "")
      .split("?")[0]
      .trim()
      .toLowerCase();
  }

  // Layout is per-product data, not a property of the URL slug. Prefer the
  // metafield; fall back to the original hardcoded handles so every product
  // keeps its current layout until the metafield is set in admin.
  function riLayoutFlag(key) {
    const value = (window.ROMAN_META || {})[key];
    return (value == null || value === "") ? null : riMetaBool(value, false);
  }

  function shouldMoveSimpleControlsAfterText(product) {
    const configured = riLayoutFlag("controls_after_text");
    if (configured !== null) return configured;

    // Legacy default: matching on the handle. Note "bag" is a substring test,
    // so any new handle containing it inherits this layout by accident.
    const handle = getCurrentProductHandle(product);
    return [
      "personalized-frosted-shot-glass-your-logo",
      "custom-promotional-sunglasses"
    ].includes(handle) || handle.includes("bag");
  }

  function shouldMoveProductColorAfterText(product) {
    const configured = riLayoutFlag("color_after_text");
    if (configured !== null) return configured;

    // Legacy default: sunglasses kept its colour carousel at the top.
    return getCurrentProductHandle(product) !== "custom-promotional-sunglasses";
  }

  // Colour sits below the tier table by default, so the quantity/pricing table
  // reads first. Set color_below_tiers=false on a product to put it back on top.
  // Ignored when color_after_text moves the carousel further down still.
  function shouldMoveColorBelowTiers() {
    const configured = riLayoutFlag("color_below_tiers");
    return configured === null ? true : configured;
  }

  function forceSelectVariantById(id) {
    const input = document.querySelector('input[name="id"]');
    if (input) {
      input.value = id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  // -----------------------------
  // 5) BOOT
  // -----------------------------
async function boot() {
  const ok = await waitForRomanMeta();
  if (!ok) {
    console.log("ROMAN: ROMAN_META not ready ❌");
    return;
  }

  loadMetaIntoState();

  const product = await getProductData();
  if (!product) return;

  STATE.product = product;
  STATE.baseVariantPrice = product.variants?.[0]?.price || 0;
  const optionInfo = detectOptionIndexes(product);
  STATE.colorIndex = optionInfo.colorIndex;
  STATE.sizeIndex = optionInfo.sizeIndex;
  STATE.productType = optionInfo.type;

  console.log("ROMAN: detected product layout", optionInfo.type, optionInfo);

  document.getElementById("ri-sets-note")?.remove();
  buildSimpleQuantityUI(product);
 }




boot();









  // common porduct design
function buildSimpleQuantityUI(product) {
  const btn = findATCButton();
  if (!btn) return null;

  document.getElementById("roman-tier-ui")?.remove();

  const { colorIndex, sizeIndex, hasColor, hasSize, type } = detectOptionIndexes(product);
  STATE.colorIndex = colorIndex;
  STATE.sizeIndex = sizeIndex;
  STATE.productType = type;

  const colorMap = new Map();
  if (hasColor) {
    product.variants.forEach((v) => {
      const options = v.options || [v.option1, v.option2, v.option3];
      const c = options[colorIndex];
      if (c && c !== "Default Title" && !colorMap.has(c)) {
        colorMap.set(c, { color: c, img: v.featured_image?.src || v.image });
      }
    });
  }

  const colorItems = Array.from(colorMap.values());
  const hasColors = hasColor && colorItems.length > 0;
  const locations = getResolvedPrintLocations(product);
  const hasPrintLocationField = STATE.showPrintLocation && locations.length > 0;
  const hasPrintColorField = STATE.showPrintColor && normalizeRiList(window.IMPRINT_COLORS).length > 0;
  let locationOptions = '<option value="" disabled selected>Choose Location...</option>';
  locations.forEach(function(loc){
    locationOptions += `<option value="${escapeRiHtml(loc)}">${escapeRiHtml(loc)}</option>`;
  });
  const moveSimpleControlsAfterText = shouldMoveSimpleControlsAfterText(product) && STATE.showTextFields;
  const moveProductColorAfterText =
    moveSimpleControlsAfterText && shouldMoveProductColorAfterText(product);
  const showCustomizationStep = hasPrintLocationField || hasPrintColorField;
  const showTextFields = STATE.showTextFields;
  const text1Label = escapeRiHtml(STATE.text1Label);
  const text2Label = escapeRiHtml(STATE.text2Label);
  const showImageTab = STATE.showUploadImage;
  const showCombinedTab = STATE.showUploadImage && STATE.showText2;
  const showArtworkMethodControls = STATE.showUploadImage;
  const showTextTab = showTextFields;
  const useTextAsDefaultTab = !showImageTab && showTextTab;
  const useContactAsDefaultTab = !showImageTab && !showTextTab;



  // ✅ show "(sets of X)" next to ATC if groupQty > 1
 function ensureSetsNoteNearATC() {
  const btn = findATCButton();
  if (!btn) return;

  document.getElementById("ri-sets-note")?.remove();

  if (STATE.groupQty > 1) {
    const note = document.createElement("span");
    note.id = "ri-sets-note";
    note.textContent = `(sets of ${STATE.groupQty})`; // initial
    note.style.marginRight = "10px";
    note.style.fontSize = "14px";
    note.style.fontWeight = "600";
    note.style.display = "inline-block";

    
    btn.parentNode.insertBefore(note, btn);
  }
 }

 function updateSetsNoteByQty(correctedQty) {
  const note = document.getElementById("ri-sets-note");
  if (!note) return;

  if (STATE.groupQty <= 1) {
    note.remove();
    return;
  }

  const show = correctedQty > 0 ? correctedQty : STATE.groupQty;
  // note.textContent = `(sets of ${show})`;
 }

  // The colour carousel is emitted in exactly one of three slots: top of the
  // panel, below the tier table, or after the text fields. Only one may render
  // or the carousel mount would bind to the wrong .ri-track.
  const colorCardHtml = `
      <section class="ri-card">
        <header class="ri-head"><h3>Product Color</h3></header>
        <div class="ri-body">
          <div class="ri-carousel">
            <button class="ri-arrow ri-prev" type="button">‹</button>
            <div class="ri-track" role="list"></div>
            <button class="ri-arrow ri-next" type="button">›</button>
          </div>
          <div class="ri-note">Product Color: <b id="ri-color-name">Select color</b></div>
        </div>
      </section>`;
  const colorInPanel = hasColors && !moveProductColorAfterText;
  const colorInPanelBelow = colorInPanel && shouldMoveColorBelowTiers();
  const colorInPanelTop = colorInPanel && !colorInPanelBelow;

  const wrapper = document.createElement("div");
  wrapper.id = "roman-tier-ui";
  wrapper.dataset.productLayout = type;
  if (!showArtworkMethodControls) {
    wrapper.classList.add("ri-no-upload-artwork");
  }
  if (moveSimpleControlsAfterText) {
    wrapper.classList.add("ri-controls-after-text");
  }

  // ✅ tier min + group min resolve
   const tierMin = Number(STATE.tiers?.[0]?.min || 1);
   const group = Number(STATE.groupQty || 1);
   // The lowest quantity that is whole sets (Jason, 30 Oct 2026: customers
   // order in sets of the case quantity): min 20 in sets of 15 starts at 30.
   const minQty = group > 1 ? Math.ceil(tierMin / group) * group : tierMin;

   

  wrapper.innerHTML = `
  <div class="ri-proof-note">Card billed after Proof is Approved</div>
  <div class="ri-delivery-line">
<span class="ri-delivery-icon" aria-hidden="true">
  <i class="fa-solid fa-truck"></i>
</span>    <span>Est. Delivery:</span>
    <strong id="dynamic-delivery-date">Calculating...</strong>
  </div>
  <div class="ri-panel">
    ${colorInPanelTop ? colorCardHtml : ''}
      <section class="ri-cardd">
        <div class="ri-body">
          <div class="ri-table-wrap">
            <table class="ri-qty-table ri-simple-tier-table">
              <thead>
                <tr>
                  <th>Quantity</th>
                  ${STATE.tiers.map(t => `<th>${t.min}+</th>`).join("")}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="ri-left-label">Price</td>
                  ${STATE.tiers.map(t => `
                    <td class="ri-reg-cell">
                      <span class="ri-reg-strike">${t.price != null ? money(t.price) : ""}</span>
                    </td>
                  `).join("")}
                </tr>
                <tr>
                  <td class="ri-left-label ri-left-empty"></td>
                  ${STATE.tiers.map(t => `
                    <td class="ri-sale-cell">
                      <span class="ri-sale-red">${money(t.sale_price)}</span>
                    </td>
                  `).join("")}
                </tr>
              </tbody>
            </table>
          </div>

          ${!moveSimpleControlsAfterText ? `
          <div class="ri-simple-qty-wrap">
            <label for="ri-simple-qty">Quantity</label>
            ${!hasSize ? `
              <div id="ri-min-banner" class="ri-min-banner">
                Minimum <span id="ri-min-qty">${minQty}</span> quantity required
              </div>
            ` : ''}
            <input type="number" id="ri-simple-qty" min="${minQty}" value="${minQty}">
            ${STATE.groupQty > 1 ? `<span id="ri-sets-note" class="ri-sets-note">(sets of ${STATE.groupQty})</span>` : ''}
          </div>
          ` : ''}

          <div class="ri-summary">
            <div>Total Qty: <b id="ri-total-qty">${minQty}</b></div>
            <div>Price each: <b id="ri-each-price">${money(STATE.tiers[0]?.sale_price)}</b></div>
            <div>Subtotal: <b id="ri-subtotal">${money(minQty * (STATE.tiers[0]?.sale_price || 0))}</b></div>
            <div>Setup fee: <b id="ri-setup-fee">${money(STATE.setupFee)}</b></div>
            <div>Grand Total: <b id="ri-grand-total"></b></div>
          </div>
        </div>
      </section>
      ${colorInPanelBelow ? colorCardHtml : ''}
</div>

<div>

 

</div>
 


${showCustomizationStep ? `
<div id="ri-customization-step" class="ri-customization-step">
  ${hasPrintLocationField ? `
    <h2 class="ri-section-title">Print Location</h2>
    <select id="ri-location-select" class="ri-select">
      ${locationOptions}
    </select>
  ` : ''}
  ${hasPrintColorField ? `
    <div class="ri-print-color-field">
      <label>Select Print Color</label>
      <div class="ri-color-dropdown-wrapper">
        <div id="ri-dropdown-header" class="ri-dropdown-header">
          <div style=" align-items: center; gap: 10px;">
            <div id="ri-selected-placeholder-palette" style="width: 25px; height: 15px; background: transparent; border-radius: 4px; border: 1px solid rgba(0,0,0,0.1);"></div>
            <span id="ri-selected-placeholder-text">-- Select Print Color --</span>
          </div>
          <span>▼</span>
        </div>
        <div id="ri-swatch-container" class="ri-swatch-container">
          <div style="padding: 10px; font-weight: bold; background: #ddd;">Available Print Colors</div>
        </div>
      </div>
    </div>
  ` : ''}
</div>
` : ''}

  




  

 <div class="artwork-wrapper">

    <div class="artwork-top">
      <div class="artwork-title">
         <span class="help"></span> 
      </div>

      <div class="artwork-choice">
        <label>
          <input type="radio" name="artwork_time" checked>
         
        </label>

        <label>
          <input type="radio" name="artwork_time">
        
        </label>
      </div>
   </div>


   <div class="ck-artwork-container">
    <div class="ck-proof-note">(Free proof sent within 48 hours)</div>
    <div class="ck-header">
     <div class="ck-header-left">
      Add Your Artwork <span class="info-icon">?</span>
    </div>
    ${showArtworkMethodControls ? `
     <div class="ck-header-right">
      <label class="ck-radio-label ck-upload-radio">
        <input type="radio" name="properties[Artwork Method]" value="Add Now" checked onclick="ckToggleMain(true)">
        <span class="ck-radio-circle"></span>
        <span class="ck-radio-main">Upload Image</span>
      </label>
      <label class="ck-radio-label">
        <input type="radio" name="properties[Artwork Method]" value="Send After Checkout" onclick="ckToggleMain(false)">
        <span class="ck-radio-circle"></span>
        <span>
          <span class="ck-radio-main">Send Image After Submitting Order</span>
        </span>
      </label>
      <!-- Lives beside the radio it describes so it lands under it at every
           width. Parked at the end of .ck-body it fell below the text fields. -->
      <div id="ck-panel-sendafter" class="ck-panel">
        <p style="font-size: 13px;">${STATE.sendAfterMessage}</p>
      </div>
    </div>
    ` : ''}
   </div>
 
   <div class="ck-body">
    <div id="ck-tabs-nav" class="ck-tabs">
		      ${showImageTab ? `
		      <div class="ck-tab-item active" onclick="ckSwitchTab('image', this)">
		        <div class="ck-icon">☆</div><div class="ck-label">Only Image</div>
		      </div>
		      ` : ''}
		      ${showTextTab ? `
		      <div class="ck-tab-item${useTextAsDefaultTab ? ' active' : ''}" onclick="ckSwitchTab('text', this)">
		        <div class="ck-icon">Aa</div><div class="ck-label">Only Text</div>
		      </div>
		      ` : ''}
		      ${showCombinedTab ? `
		      <div class="ck-tab-item" onclick="ckSwitchTab('both', this)">
		        <div class="ck-icon">Aa☆</div><div class="ck-label">Text/Image</div>
		      </div>
		      ` : ''}
	     
	      <div class="ck-tab-item${useContactAsDefaultTab ? ' active' : ''}" onclick="ckSwitchTab('contact', this)">
	        <div class="ck-icon">👤</div><div class="ck-label">Contact Us</div>
	      </div>
    </div>

    
 
    <div id="ck-content-area">




     
	                ${showImageTab ? `
	                <div id="ck-panel-image" class="ck-panel active">
                  <div class="ck-file-input">
          <input type="text" id="file-name-1" placeholder="Choose file" readonly>
          <label class="ck-browse-btn">
            Choose File
            <input type="file" id="artwork-file-1" name="properties[Artwork Image]" accept="image/*" onchange="handleDynamicPreview(this, '1')">
          </label>
        </div>
        <div class="ck-file-formats">Accepted File Formats: jpeg, png, pdf, svg, ai</div>

        <div id="preview-container-1" style="display:none; margin-top: 15px;">
          <div style="position: relative; width: 150px; height: 150px;">
            <img id="image-preview-snapshot-1" src="" style="width: 150px; height: 150px; object-fit: cover; border: 1px solid #ddd; border-radius: 4px;">
            <span onclick="clearDynamicImage('1')" style="position: absolute; top: -10px; right: -10px; background: red; color: white; width: 22px; height: 22px; border-radius: 50%; text-align: center; cursor: pointer; line-height: 20px; font-weight: bold;">×</span>
          </div>
          <div style="margin-top: 10px;">
            <button type="button" onclick="saveDynamicImage('1')" style="background: #000; color: #fff; padding: 5px 15px; cursor: pointer; border: none;">Save Image</button>
          </div>
        </div>
        </div>
        ` : ''}



 
      ${showTextFields ? `
      <div class="ri-text-fields">
        ${STATE.showText1 ? `
        <label for="ri-display-text-1">${text1Label}</label>
        <textarea id="ri-display-text-1" class="ri-textarea" rows="2" oninput="document.getElementById('hidden-only-text') && (document.getElementById('hidden-only-text').value = this.value)"></textarea>
        ${STATE.showFont1 ? `
        <select class="ri-select ri-font-select" onchange="formatDoc('fontName', this.value); applyRiTextareaFont(this)">
          ${riFontOptionsHtml(true)}
        </select>
        ` : ''}
        ` : ''}
        ${STATE.showText2 ? `
        <label for="ri-display-text-2">${text2Label}</label>
        <textarea id="ri-display-text-2" class="ri-textarea" rows="2" oninput="document.getElementById('hidden-both-text') && (document.getElementById('hidden-both-text').value = this.value)"></textarea>
        ${STATE.showFont2 ? `
        <select class="ri-select ri-font-select" onchange="formatDoc('fontName', this.value); applyRiTextareaFont(this)">
          ${riFontOptionsHtml(true)}
        </select>
        ` : ''}
        ` : ''}
        ${moveSimpleControlsAfterText ? `
          <div class="ri-simple-controls-after-text">
            <div class="ri-simple-qty-wrap">
              <label for="ri-simple-qty">Quantity</label>
              ${!hasSize ? `
                <div id="ri-min-banner" class="ri-min-banner">
                  Minimum <span id="ri-min-qty">${minQty}</span> quantity required
                </div>
              ` : ''}
              <input type="number" id="ri-simple-qty" min="${minQty}" value="${minQty}">
              ${STATE.groupQty > 1 ? `<span id="ri-sets-note" class="ri-sets-note">(sets of ${STATE.groupQty})</span>` : ''}
            </div>

            ${hasColors && moveProductColorAfterText ? `
              <section class="ri-card ri-color-card-after-text">
                <header class="ri-head"><h3>Product Color</h3></header>
                <div class="ri-body">
                  <div class="ri-carousel">
                    <button class="ri-arrow ri-prev" type="button">‹</button>
                    <div class="ri-track" role="list"></div>
                    <button class="ri-arrow ri-next" type="button">›</button>
                  </div>
                  <div class="ri-note">Product Color: <b id="ri-color-name">Select color</b></div>
                </div>
              </section>
            ` : ''}
          </div>
        ` : ''}
      </div>
      ` : ''}

	      ${showTextTab ? `
	      <div id="ck-panel-text" class="ck-panel${useTextAsDefaultTab ? ' active' : ''}">
        <div class="ck-rich-editor">
          <div class="ck-toolbar">
                ${STATE.showFont1 ? `
                <select class="ri-font-select" onchange="formatDoc('fontName', this.value)" style="font-family: inherit;">
                  ${riFontOptionsHtml(false)}
                </select>
                ` : ''}
                <select onchange="formatDoc('fontSize', this.value)">
                ${STATE.editorSizes.map(s => `<option value="${s}">${s}px</option>`).join('')}
              </select>
            <button type="button" onclick="formatDoc('bold')"><b>B</b></button>
            <button type="button" onclick="formatDoc('italic')"><b><i>I</i></b></button>
            <span class="ck-sep"></span>
            <button type="button" onclick="formatDoc('justifyLeft')"><i class="fa-solid fa-align-left"></i></button>
            <button type="button" onclick="formatDoc('justifyCenter')"><i class="fa-solid fa-align-center"></i></button>
            <button type="button" onclick="formatDoc('justifyRight')"><i class="fa-solid fa-align-right"></i></button>
          </div>
          <div id="editor-only-text" class="ck-text-box" contenteditable="true" oninput="syncText('editor-only-text', 'hidden-only-text')"></div>
          <input type="hidden" name="properties[Custom Text]" id="hidden-only-text">
        </div>
      </div>
 
      <div id="ck-panel-both" class="ck-panel">
        <div class="ck-rich-editor" style="margin-bottom: 15px;">
          <div class="ck-toolbar">
                ${STATE.showFont2 ? `
                <select class="ri-font-select" onchange="formatDoc('fontName', this.value)" style="font-family: inherit;">
                  ${riFontOptionsHtml(false)}
                </select>
                ` : ''}
              <select onchange="formatDoc('fontSize', this.value)">
                ${STATE.editorSizes.map(s => `<option value="${s}">${s}px</option>`).join('')}
              </select>
            <button type="button" onclick="formatDoc('bold')"><b>B</b></button>
            <button type="button" onclick="formatDoc('italic')"><b><i>I</i></b></button>
            <span class="ck-sep"></span>
            <button type="button" onclick="formatDoc('justifyLeft')"><i class="fa-solid fa-align-left"></i></button>
            <button type="button" onclick="formatDoc('justifyCenter')"><i class="fa-solid fa-align-center"></i></button>
            <button type="button" onclick="formatDoc('justifyRight')"><i class="fa-solid fa-align-right"></i></button>
          </div>
          <div id="editor-both" class="ck-text-box" contenteditable="true" style="min-height: 80px;" oninput="syncText('editor-both', 'hidden-both-text')"></div>
          <input type="hidden" name="properties[Custom Text (Combined)]" id="hidden-both-text">
        </div>


              <div class="ck-file-input">
        <input type="text" id="file-name-2" placeholder="Choose file" readonly>
        <label class="ck-browse-btn">
          Browse
          <input type="file" id="artwork-file-2" name="properties[Artwork Image (Combined)]" accept="image/*" onchange="handleDynamicPreview(this, '2')">
        </label>
      </div>

      <div id="preview-container-2" style="display:none; margin-top: 15px;">
        <div style="position: relative; width: 150px; height: 150px;">
          <img id="image-preview-snapshot-2" src="" style="width: 150px; height: 150px; object-fit: cover; border: 1px solid #ddd; border-radius: 4px;">
          <span onclick="clearDynamicImage('2')" style="position: absolute; top: -10px; right: -10px; background: red; color: white; width: 22px; height: 22px; border-radius: 50%; text-align: center; cursor: pointer; line-height: 20px; font-weight: bold;">×</span>
        </div>
        <div style="margin-top: 10px;">
          <button type="button" onclick="saveDynamicImage('2')" style="background: #000; color: #fff; padding: 5px 15px; cursor: pointer; border: none;">Save Image</button>
        </div>
      </div>



      </div>
      ` : ''}
 
      
      <div id="ck-panel-contact" class="ck-panel${useContactAsDefaultTab ? ' active' : ''}">
              <p style="font-size: 13px;">${STATE.contactTabText}</p>
            </div>
          </div>

 
    </div>
</div>
  <div class="ri-size-wrap ri-simple-size-wrap" id="ri-size-wrap">
    <div class="ri-size-title">Quantity</div>
    <div id="ri-min-banner" class="ri-min-banner">
      Minimum <span id="ri-min-qty">${minQty}</span> quantity required
    </div>
    <div class="ri-size-grid" id="ri-size-grid"></div>
  </div>

  <div id="ri-order-summary" class="ri-order-summary">

    <div class="ri-order-total-row">
    <span>Total</span>
    <span id="ri-final-total">$0.00</span>
    </div>

    <div style="padding:12px 5px;font-size:14px">

    <div style="display:flex;justify-content:space-between;margin-bottom:6px">
    <span id="ri-qty-line">0 qty x $0.00</span>
    <span id="ri-subtotal-show">$0.00</span>
    </div>

    <div style="display:flex;justify-content:space-between;margin-bottom:6px">
    <span>Setup fee:</span>
    <span id="ri-setup-show">$0.00</span>
    </div>

    <div id="delivery-timeframe-display" style="margin-top: 10px; text-align:center;">
      <p style="margin: 0; font-size: 14px; color: #333;">
        <strong style="color: #d9534f;">🚚 Est. Delivery:</strong> 
        <span id="dynamic-delivery-date" style="font-weight: 700;">Calculating...</span>
      </p>
    </div>

    

    

  </div>

   <div class="custom-atc-wrapper" style="margin-top: 20px;">
    <button type="button" id="trigger-real-atc" 
            class="ri-add-to-cart-btn">
      ADD TO CART
      
    </button>
    
 </div>

  `;

  // ✅ carousel mount (only if colors exist)
  if (hasColors) {
    const track = wrapper.querySelector(".ri-track");
    if (track) {
      track.innerHTML = colorItems.map(item => `
        <div class="ri-item" data-color="${item.color}" style="cursor:pointer;">
          <img class="ri-thumb" src="${item.img}" alt="${item.color}">
          <div class="ri-name">${item.color}</div>
        </div>
      `).join("");

      wrapper.querySelectorAll(".ri-item").forEach(item => {
        item.addEventListener("click", function (event) {
          wrapper.querySelectorAll(".ri-item").forEach(i => i.classList.remove("is-active"));
          this.classList.add("is-active");
          wrapper.querySelector("#ri-color-name").textContent = this.dataset.color;
          STATE.selectedColor = this.dataset.color;

          const selectedVariant = product.variants.find(
            v => (v.options || [v.option1])[colorIndex] === this.dataset.color
          );
          if (selectedVariant) {
            setMainProductImage(selectedVariant.featured_image?.src || selectedVariant.image);
            forceSelectVariantById(selectedVariant.id);
          }

          if (hasSize) {
            renderSimpleSizes(this.dataset.color);
          } else {
            renderTotals(Number(qtyInput?.value || minQty));
          }

          // Shoppers' taps only: the preselect from the URL and the cart
          // edit prefill click too, and must not move the page.
          if (event.isTrusted) riShowGalleryOnMobile();
        });
      });

      wrapper.querySelector(".ri-prev").onclick = () =>
        track.scrollBy({ left: -240, behavior: "smooth" });
      wrapper.querySelector(".ri-next").onclick = () =>
        track.scrollBy({ left: 240, behavior: "smooth" });
    }
  }

  function getSimpleSizes(color) {
    if (!hasSize) return [];
    const byColor = sizeIndex === -1 ? riSizesByColor() : null;
    if (byColor) return [...((color && byColor[color]) || Object.values(byColor)[0] || [])];

    const names = [];
    product.variants.forEach((variant) => {
      const options = variant.options || [variant.option1, variant.option2, variant.option3];
      if (hasColors && color && options[colorIndex] !== color) return;
      const size = options[sizeIndex];
      if (size && size !== "Default Title" && !names.includes(size)) names.push(size);
    });
    return names;
  }

  function getSimpleSizeUpchargeAmount(size) {
    // Single source of truth — see riSizeUpcharge (hoisted to IIFE scope).
    return riSizeUpcharge(size);
  }

  function renderSimpleSizes(color) {
    const sizeWrap = wrapper.querySelector("#ri-size-wrap");
    const sizeGrid = wrapper.querySelector("#ri-size-grid");
    if (!sizeWrap || !sizeGrid) return;

    if (!hasSize) {
      wrapper.classList.remove("ri-has-size-grid");
      sizeWrap.style.display = "none";
      sizeGrid.innerHTML = "";
      return;
    }

    const sizeLabelMap = {
      s: "Small",
      small: "Small",
      m: "Medium",
      medium: "Medium",
      l: "Large",
      large: "Large",
      xl: "XL",
      xxl: "XXL",
      "2xl": "XXL",
      "2x": "XXL"
    };
    // Sizes it does not know (youth, toddler, waist) keep the product's own order.
    const sizeRank = {
      xxs: 0.4, "2xs": 0.4, xs: 0.5,
      small: 1,
      medium: 2,
      large: 3,
      xl: 4,
      xxl: 5,
      "3xl": 6, xxxl: 6, "4xl": 7, "5xl": 8, "6xl": 9
    };

    const displaySizeName = (size) => {
      const clean = String(size).replace(/\s*\+\$.*$/i, "").trim();
      return sizeLabelMap[clean.toLowerCase()] || clean;
    };

    const getSizeRank = (size) => {
      const normalized = displaySizeName(size).toLowerCase();
      return sizeRank[normalized] || 99;
    };

    const sizes = getSimpleSizes(color).sort((a, b) => getSizeRank(a) - getSizeRank(b));
    if (!sizes.length) {
      wrapper.classList.remove("ri-has-size-grid");
      sizeWrap.style.display = "none";
      return;
    }

    wrapper.classList.add("ri-has-size-grid");
    sizeGrid.innerHTML = sizes.map((size) => {
      const label = displaySizeName(size);
      const upcharge = getSimpleSizeUpchargeAmount(size);
      return `
        <label class="ri-size">
          <span>${label}</span>
          <input type="number" min="0" value="0" data-size="${size}">
          ${upcharge ? `<small>+$${upcharge.toFixed(2)}</small>` : ""}
        </label>
      `;
    }).join("");

    const syncSizeTotal = () => {
      const total = Array.from(sizeGrid.querySelectorAll("input")).reduce((sum, input) => {
        return sum + (parseInt(input.value || 0, 10) || 0);
      }, 0);
      qtyInput.value = String(total || 0);
      renderTotals(total || 0);
    };

    sizeGrid.querySelectorAll("input").forEach((input, index) => {
      if (index === 0) input.value = String(minQty);
      input.addEventListener("input", syncSizeTotal);
      input.addEventListener("change", syncSizeTotal);
    });

    sizeWrap.style.display = "block";
    syncSizeTotal();
  }

  const form = btn.closest("form");

  
  form.parentNode.insertBefore(wrapper, form);


  renderImprintColors(); 
  updateDeliveryDate();
 updateCustomizationSummary();
      
  updateSetsNoteByQty(minQty);  

  // Quantity at the bottom, above the order total, on every product type
  // (Jason, 28 Oct 2026), wherever the layout flags drew it. Apparel keeps
  // its size grid there instead.
  if (!hasSize) {
    const qtyWrap = wrapper.querySelector(".ri-simple-qty-wrap");
    const orderSummary = wrapper.querySelector("#ri-order-summary");
    if (qtyWrap && orderSummary) {
      qtyWrap.classList.add("ri-simple-qty-bottom");
      orderSummary.before(qtyWrap);
    }
  }

  const qtyInput = wrapper.querySelector("#ri-simple-qty");
  const banner = wrapper.querySelector("#ri-min-banner");

  // ✅ ensure shopify quantity input exists
  function setShopifyQuantityOnForm(formEl, qty) {
    if (!formEl) return;
    let q = formEl.querySelector('input[name="quantity"]');
    if (!q) {
      q = document.createElement("input");
      q.type = "hidden";
      q.name = "quantity";
      formEl.appendChild(q);
    }
    q.value = String(qty);
    q.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function setATCEnabled(enabled) {
    if (!btn) return;
    btn.disabled = !enabled;
    btn.style.opacity = enabled ? "1" : "0.6";
    btn.style.cursor = enabled ? "pointer" : "not-allowed";
  }

  function getTierForQty(qty) {
    return STATE.tiers.slice().filter(t => qty >= t.min).pop() || STATE.tiers[0];
  }

  function roundQty(qty){
    let q = Number(qty || 0);
    if(!Number.isFinite(q)) q = 0;

    if(group > 1 && q > 0){
      q = Math.ceil(q / group) * group;
    }

    return q;
  }

function renderTotals(qty) {
  // ✅ Banner hide/show logic ADD koro
  const bannerEl = wrapper.querySelector("#ri-min-banner");
  if (qty >= minQty) {
    if (bannerEl) bannerEl.style.display = "none";
    setATCEnabled(true);
  } else {
    if (bannerEl) bannerEl.style.display = "block";
    setATCEnabled(false);
  }

  let each = 0;
  if (qty >= minQty) {
    const tier = getTierForQty(qty);
    each = Number(tier?.sale_price || 0);
  }

  const sizeInputs = Array.from(wrapper.querySelectorAll("#ri-size-grid input"));
  const hasSizeQty = sizeInputs.some((input) => Number(input.value || 0) > 0);
  let subtotal = qty * each;

  if (hasSizeQty) {
    subtotal = sizeInputs.reduce((sum, input) => {
      const sizeQty = Math.max(0, parseInt(input.value || 0, 10) || 0);
      if (!sizeQty) return sum;
      return sum + sizeQty * (each + getSimpleSizeUpchargeAmount(input.dataset.size));
    }, 0);
  }

  const grand = qty > 0 ? subtotal + (Number(STATE.setupFee || 0)) : 0;
  STATE.totalQty = qty;
  STATE.unitPrice = each;
  STATE.subtotal = subtotal;
  STATE.grandTotal = grand;

  wrapper.querySelector("#ri-total-qty").textContent = String(qty);
  wrapper.querySelector("#ri-each-price").textContent = money(each);
  wrapper.querySelector("#ri-subtotal").textContent = money(subtotal);
  wrapper.querySelector("#ri-grand-total").textContent = money(grand);

  setShopifyQuantityOnForm(form, qty);
  updateSetsNoteByQty(qty);
  updateFirstPageTotal();
  updateCustomizationSummary(); 
}
  
  let typingTimer = null;

  
  
 

 

    // init
  const initial = minQty;
  qtyInput.value = String(initial);
  renderTotals(initial);
  if (hasSize) {
    renderSimpleSizes(STATE.selectedColor);
  } else {
    wrapper.querySelector("#ri-size-wrap")?.style.setProperty("display", "none", "important");
  }

  // ✅ valid quantity
  

    

qtyInput.addEventListener("input", () => {
  const raw = parseInt(qtyInput.value || 0, 10);
  const rawQty = Number.isFinite(raw) ? raw : 0;
  renderTotals(rawQty);
 });
 
qtyInput.addEventListener("blur", () => {
  let val = parseInt(qtyInput.value || 0);
  const groupQtyVal = Number(STATE.groupQty || 1);

  if (groupQtyVal > 1 && val > 0) {
    val = Math.ceil(val / groupQtyVal) * groupQtyVal;
    qtyInput.value = val;

    renderTotals(val); // 🔥 update price after round
  }
});

  if (hasColors) riPreselectColorFromUrl(wrapper, product, colorIndex);

  // One colour only: no colour picker on the page (Jason, 28 Oct 2026), but
  // it is still selected, so the colour reaches the cart, checkout and receipt.
  if (hasColors && colorItems.length === 1) {
    const only = wrapper.querySelector(".ri-item");
    if (only && !only.classList.contains("is-active")) only.click();
    only?.closest(".ri-card")?.classList.add("ri-single-color");
  }

  bindRiFontSelects(wrapper);
  setTimeout(() => bindRiFontSelects(wrapper), 300);

  return wrapper;
}







// Zip   Code Method

function initShippingLogic() {
    const zipBtn = document.querySelector('#ri-zip-apply-btn');
    const zipInput = document.querySelector('#ri-zip-input');
    const shippingWrapper = document.querySelector('#ri-shipping-wrapper');
    const shippingSelect = document.querySelector('#ri-shipping-dropdown');
    const hiddenJsonInput = document.querySelector('#ri-shipping-json-meta');

    if (!zipBtn) return;

   zipBtn.onclick = function(e){

e.preventDefault();

const zipValue = zipInput.value.trim();

try {

const allMethods = JSON.parse(hiddenJsonInput.value);

const methods = allMethods[zipValue];

if(!methods){

alert("No shipping available for this ZIP code");
return;

}

shippingWrapper.style.display="block";

shippingSelect.innerHTML =
'<option value="" disabled selected>Select an option</option>';

methods.forEach(function(m){

let opt=document.createElement("option");

opt.value=m.price;

opt.dataset.arrival=m.days;

opt.textContent=
m.name + " (" + m.days + ") - $" + m.price;

shippingSelect.appendChild(opt);

});

}

catch(err){

console.error("Shipping JSON error",err);

}

};

shippingSelect.onchange = function() {

window.selectedShippingPrice = parseFloat(this.value);
const arrival = this.options[this.selectedIndex].dataset.arrival;

document.getElementById("ri-arrival").innerText = arrival;


updateFirstPageTotal();
updateCustomizationSummary();

// show total box
const box = document.getElementById("ri-first-total-box");
if(box){
box.style.display = "flex";
}

};
}


function updateSummaryTable() {
    const setupMeta = document.querySelector('#ri-setup-fee-meta');
    const setupVal = setupMeta ? parseFloat(setupMeta.value) : 50;
    const setupRaw = setupVal * 100;

    const qtyInput = document.querySelector('input[name="quantity"]');
    const qty = parseInt(qtyInput ? qtyInput.value : 1);
    
    if (typeof STATE !== 'undefined' && STATE.tiers) {
        const currentTier = STATE.tiers.slice().reverse().find(t => qty >= t.min) || STATE.tiers[0];
        const unitPriceRaw = currentTier.sale_price; 
        const subTotalRaw = qty * unitPriceRaw;
        
        const shippingRaw = window.selectedShippingPrice || 0;
        const totalRaw = subTotalRaw + shippingRaw + setupRaw;

        
        document.getElementById('ri-grand-total').innerText = money(totalRaw);
        document.getElementById('ri-qty-text').innerText = qty + ' qty x ' + money(unitPriceRaw);
        document.getElementById('ri-subtotal').innerText = money(subTotalRaw);
        document.getElementById('ri-setup-fee').innerText = money(setupRaw);
        document.getElementById('ri-shipping-cost').innerText = money(shippingRaw);
    }
}


document.addEventListener('DOMContentLoaded', initShippingLogic);
setTimeout(initShippingLogic, 2000);









// ✅ Page 2: Location + Imprint Color pre-fill
if (window._editLocation || window._editImprintColor) {
    setTimeout(() => {
        // Location
        const locationSelect = document.getElementById('ri-location-select');
        if (locationSelect && window._editLocation) {
            locationSelect.value = window._editLocation;
        }

        // Imprint Color
        if (window._editImprintColor) {
            document.querySelectorAll('.ri-imprint-row').forEach(row => {
                if (row.dataset.name === window._editImprintColor) {
                    row.click();
                }
            });
        }

        window._editLocation     = null;
        window._editImprintColor = null;
    }, 600);
}

function updateDeliveryDate() {
    const targets = document.querySelectorAll('[id="dynamic-delivery-date"]');
    if (!targets.length) return;

    const isWeekend = (date) => {
        const day = date.getDay();
        return day === 0 || day === 6;
    };

    const normalizeToBusinessDay = (date) => {
        const result = new Date(date);
        while (isWeekend(result)) {
            result.setDate(result.getDate() + 1);
        }
        return result;
    };

    const addBusinessDays = (startDate, businessDays) => {
        const result = normalizeToBusinessDay(startDate);
        let remaining = Math.max(0, Number(businessDays) || 0);

        while (remaining > 0) {
            result.setDate(result.getDate() + 1);
            if (!isWeekend(result)) {
                remaining -= 1;
            }
        }

        return normalizeToBusinessDay(result);
    };

    const today = normalizeToBusinessDay(new Date());
    const deliveryDaysRaw =
        window.ROMAN_META?.delivery_time ??
        window.ROMAN_META?.production_time ??
        window.STATE?.productionTime ??
        0;
    const productionDays = Math.max(0, parseInt(deliveryDaysRaw, 10) || 0);
    const startDate = addBusinessDays(today, productionDays);
    const endDate = addBusinessDays(startDate, 2);

    // "Nov. 18 - Nov. 20": short months, so the line fits on one row on a
    // phone (Jason, 28 Oct 2026). May is not shortened, so it has no period.
    const MONTHS = ["Jan.", "Feb.", "Mar.", "Apr.", "May", "Jun.", "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."];
    const short = (d) => `${MONTHS[d.getMonth()]} ${d.getDate()}`;
    const dateText = short(startDate) + " - " + short(endDate);

    targets.forEach((target) => {
        target.innerText = dateText;
    });
}

window.updateDeliveryDate = updateDeliveryDate;
setTimeout(updateDeliveryDate, 400);

let deliveryDateAttempts = 0;
const deliveryDateTimer = setInterval(() => {
    updateDeliveryDate();
    deliveryDateAttempts += 1;
    const stillCalculating = Array.from(document.querySelectorAll('[id="dynamic-delivery-date"]'))
        .some((target) => target.textContent.trim().toLowerCase().includes('calculating'));

    if (deliveryDateAttempts >= 20 || !stillCalculating) {
        clearInterval(deliveryDateTimer);
    }
}, 300);
        
  



/**
 * Creates and displays a popup message relative to the button position
 */
function renderValidationPopup(element, message) {
    // Remove existing popups
    const existing = document.querySelector('.ri-error-popup');
    if (existing) existing.remove();

    const popup = document.createElement('div');
    popup.className = 'ri-error-popup';
    popup.textContent = message;
    
    // Applying styles to ensure it floats above the button correctly
    Object.assign(popup.style, {
        position: 'fixed',
        background: '#e60000',
        color: '#ffffff',
        padding: '10px 15px',
        borderRadius: '5px',
        fontSize: '14px',
        fontWeight: 'bold',
        zIndex: '1000000',
        boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
        pointerEvents: 'none',
        textAlign: 'center',
        maxWidth: 'min(420px, calc(100vw - 30px))',
        whiteSpace: 'normal'
    });

    // Calculate position
    const rect = element.getBoundingClientRect();
    popup.style.visibility = 'hidden';
    document.body.appendChild(popup);

    const popupRect = popup.getBoundingClientRect();
    const top = Math.max(12, rect.top - popupRect.height - 10);
    const left = Math.min(
        Math.max(12, rect.left + (rect.width / 2) - (popupRect.width / 2)),
        window.innerWidth - popupRect.width - 12
    );
    popup.style.top = top + 'px';
    popup.style.left = left + 'px';
    popup.style.visibility = 'visible';

    // Auto-remove after 2 seconds
    setTimeout(() => { 
        if(popup && popup.parentNode) popup.parentNode.removeChild(popup); 
    }, 2000);
}

function cleanFieldLabel(label) {
    return String(label || '')
        .replace(/\s*\*+\s*$/, '')
        .replace(/^select\s+/i, '')
        .replace(/^choose\s+/i, '')
        .replace(/\s+/g, ' ')
        .trim();
}

function requiredFieldMessage(label) {
    const cleanLabel = cleanFieldLabel(label) || 'this option';
    return `Please select ${cleanLabel}.`;
}

function getPrintLocationLabel() {
    const heading = document.querySelector('#ri-customization-step .ri-section-title');
    return cleanFieldLabel(heading?.textContent) || 'Print Location';
}

function getPrintColorLabel() {
    const label = document.querySelector('.ri-print-color-field label');
    return cleanFieldLabel(label?.textContent) || 'Print Color';
}

function getStoredPrintLocation(p) {
    return p['Print Location'] || p['Imprint Location'] || '';
}

function getStoredPrintColor(p) {
    return p['Print Color'] || p['Imprint Color'] || '';
}

function riTruncateText(value, limit = 35) {
    const text = riStripTags(value).trim();
    if (text.length <= limit) return text;
    return text.slice(0, Math.max(0, limit - 3)).trimEnd() + '...';
}

function riMoneyFromNumber(value) {
    const amount = Number(value || 0);
    if (!Number.isFinite(amount) || amount <= 0) return '';
    return '+$' + amount.toFixed(2);
}

// Format a Shopify cart price (integer cents) as money. Cart prices are live:
// unlike the 'Unit Price'/'Order Total' line-item properties, which are a text
// snapshot taken at add-to-cart time and never change, these track the real
// quantity and are what the customer is actually charged.
function riMoneyFromCents(cents) {
    const amount = Number(cents || 0) / 100;
    if (!Number.isFinite(amount)) return '';
    // $1,356.50 like Shopify's subtotal under it, not $1356.50.
    return '$' + amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function getSelectedPrintColor() {
    const selectedImprintRow = document.querySelector('.ri-imprint-row.is-selected');
    const imprintPlaceholderEl = document.getElementById('ri-selected-placeholder-text');

    if (selectedImprintRow) {
        return (selectedImprintRow.getAttribute('data-name') || '').trim();
    }

    if (imprintPlaceholderEl) {
        const txt = imprintPlaceholderEl.innerText.trim();
        if (txt && txt !== '-- Select Print Color --') return txt;
    }

    return '';
}

function getPropertyLabel(input) {
    const field = input.closest('.product-form__input, .customization-option, .artwork-wrapper') || document;
    const label = input.id ? field.querySelector(`label[for="${input.id}"]`) : null;
    const propertyName = input.name?.match(/^properties\[(.+)\]$/)?.[1];
    return cleanFieldLabel(label?.textContent || propertyName || input.getAttribute('aria-label'));
}

function isVisibleField(input) {
    if (input.disabled || input.type === 'hidden') return false;
    return Boolean(input.offsetWidth || input.offsetHeight || input.getClientRects().length);
}

function requiredPropertyInputMissing(input) {
    if (!input.required || !isVisibleField(input)) return false;

    if (input.type === 'radio' || input.type === 'checkbox') {
        return !Array.from(document.querySelectorAll('input[name^="properties["]'))
            .some((field) => field.name === input.name && field.checked);
    }

    if (input.type === 'file') {
        return !(input.files && input.files.length) && !(window._editArtwork && window._editArtwork.name === input.name);
    }

    return !String(input.value || '').trim();
}

function findMissingRequiredPropertyInput() {
    const inputs = document.querySelectorAll(
        'input[name^="properties["][required], textarea[name^="properties["][required], select[name^="properties["][required]'
    );
    return Array.from(inputs).find(requiredPropertyInputMissing) || null;
}

function isUploadArtworkRequiredMissing() {
    const selectedArtworkMethod = document.querySelector('input[name="properties[Artwork Method]"]:checked');
    if (!selectedArtworkMethod || selectedArtworkMethod.value !== 'Add Now') return false;

    const fileInputs = Array.from(document.querySelectorAll('input[type="file"][name^="properties[Artwork Image"]'));
    if (!fileInputs.length) return false;

    const hasNewUpload = fileInputs.some((input) => input.files && input.files.length > 0);
    const hasExistingUpload = Boolean(window._editArtwork && window._editArtwork.value);
    return !hasNewUpload && !hasExistingUpload;
}

// The theme bakes `is-empty` into the Liquid at page-render time and puts it on
// the OUTER <cart-drawer> element, which renderContents() never replaces — it only
// swaps #CartDrawer's inner HTML. So the class goes stale the moment the cart
// changes over AJAX, and component-cart-drawer.css keys the empty message off it
// (`cart-drawer:not(.is-empty) .cart-drawer__warnings { display: none }`).
// Left ON after the first add, the drawer looks empty though it has items; left OFF
// after the last remove, the empty markup is CSS-hidden and the drawer paints blank.
// So sync it to the real cart rather than blindly clearing it. Top-up lines don't
// count: a cart holding only top-ups is empty as far as the shopper is concerned.
function syncRomanCartEmptyState(cart) {
    if (!Array.isArray(cart?.items)) return; // unknown cart: leave the theme's class alone

    const isEmpty = !cart.items.some((i) => !(i.properties || {})[RI_TOPUP_PARENT_KEY]);

    document.querySelectorAll('cart-drawer').forEach((el) => {
        // Only claim empty when the section was RENDERED empty: the 'Your cart is
        // empty' block exists solely in the Liquid's `cart == empty` branch. Setting
        // the class on markup rendered WITH items doesn't conjure that block — it
        // just collapses the drawer to a blank panel under a 'Your cart' heading.
        const flag = isEmpty && Boolean(el.querySelector('.drawer__inner-empty'));
        el.classList.toggle('is-empty', flag);
        el.querySelector('.drawer__inner')?.classList.toggle('is-empty', flag);
    });
    document.querySelectorAll('cart-drawer-items, cart-items-component').forEach((el) => {
        el.classList.toggle('is-empty', isEmpty);
    });
}

async function fetchRomanCartSections(sectionIds) {
    if (!sectionIds || !sectionIds.length) return null;

    const url = new URL(window.location.pathname, window.location.origin);
    url.searchParams.set('sections', sectionIds.join(','));
    url.searchParams.set('sections_url', window.location.pathname);

    const response = await fetch(url.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        cache: 'no-store'
    });

    if (!response.ok) return null;
    return await response.json();
}

async function refreshRomanCartDrawer(cartState, sectionIds) {
    const cartDrawer = document.querySelector('cart-drawer');
    const drawerItems = document.querySelector('cart-drawer-items');
    if (!cartDrawer && !drawerItems) return;

    let state = cartState || {};

    if (!state.sections || !state.sections['cart-drawer']) {
        try {
            const freshSections = await fetchRomanCartSections(sectionIds || ['cart-drawer', 'cart-icon-bubble']);
            if (freshSections) {
                state = {
                    ...state,
                    sections: {
                        ...(state.sections || {}),
                        ...freshSections
                    }
                };
            }
        } catch (err) {
            console.error('ROMAN: cart section refresh failed', err);
        }
    }

    // No empty-state fiddling here: this function is often handed an /cart/add.js
    // response, which is a LINE ITEM and has no .items, so it cannot tell whether the
    // cart is empty. patchCartDrawer always has a real cart and owns the sync.
    riSetCartLoading(true); // hide the unpatched frame this render is about to paint
    if (state.sections) {
        let renderedByDrawer = false;

        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            // renderContents() finishes by calling open(), and open() unconditionally
            // replays a 0.3s slide-in from translateX(100%) — it never checks whether the
            // drawer is already on screen. Right for the first render; for every render
            // after it, the drawer visibly slides in over itself. One add-to-cart renders
            // more than once (add -> top-up -> reprice), so the shopper sees two or three
            // 'eyelid' flashes, worst on mobile where the drawer is full-width.
            // Suppress open() when it is already open, exactly as riForceCloseDrawer does.
            const alreadyOpen = cartDrawer.classList.contains('active');
            if (alreadyOpen) cartDrawer.open = () => {};
            try {
                cartDrawer.renderContents(state);
                renderedByDrawer = true;
            } catch (err) {
                console.error('ROMAN: cart drawer render failed', err);
            } finally {
                // renderContents queues its open() on a 0ms timer, so restore behind it.
                if (alreadyOpen) setTimeout(() => { delete cartDrawer.open; }, 0);
            }
        }

        if (!renderedByDrawer && drawerItems && typeof drawerItems.updateSections === 'function') {
            drawerItems.updateSections(state.sections);
        }

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: state }));
    } else if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
    }

    setTimeout(patchCartDrawer, 500);
}


/*
 * Artwork for print methods that have no ink colour.
 *
 * The Select Print Color list is built from `custom.imprint_colors`, whose
 * entries are `Name|#hex` pairs. That shape only describes a flat ink, so a
 * method like full colour, laser engraving or embroidery has nothing sensible
 * to put after the pipe. Those entries carry `#ffffff`, which is why full
 * colour drew a blank white rectangle: the swatch was doing exactly what the
 * data said.
 *
 * So the hex is no longer the last word. A print method may instead be drawn
 * with a CSS background, and the name decides which:
 *
 *   1. an image uploaded in Theme settings > Print method swatches, if one is
 *      set for this method
 *   2. otherwise the built-in background below, if the name is one of these
 *   3. otherwise the hex from the metafield, as before
 *
 * The built-ins mean full colour reads as a rainbow with nothing to set up,
 * and the upload exists because a photograph of real embroidery or a real
 * engraving says more than any gradient can. Neither touches the product
 * data: no metafield changes, so nothing has to be pushed to 4,000 products
 * to change how a swatch looks.
 */
/*
 * The spectrum is drawn two ways, because the swatch is two shapes.
 *
 * roman-imprint.css forces the swatch beside the closed dropdown to an 18px
 * circle, while the rows inside the list are 60x20 bars. A band of colour
 * across a circle reads as a striped flag; a colour wheel stretched into a
 * wide bar reads as a smear. So the bar gets the linear spectrum and the
 * circle gets the wheel, which is also the symbol the print trade already
 * uses for full colour.
 */
const RI_RAINBOW_BAR =
    "linear-gradient(90deg,#e81123 0%,#ff8c00 17%,#fff100 34%,#16c60c 51%,#00b7c3 66%,#0078d7 83%,#8e2de2 100%)";

const RI_RAINBOW_WHEEL =
    "conic-gradient(#e81123,#ff8c00,#fff100,#16c60c,#00b7c3,#0078d7,#8e2de2,#e81123)";

const RI_RAINBOW = { bar: RI_RAINBOW_BAR, round: RI_RAINBOW_WHEEL };

const RI_SWATCH_BACKGROUNDS = {
    /* Both are unlimited-colour processes, so both get the full spectrum. */
    "full color": RI_RAINBOW,
    "full colour": RI_RAINBOW,
    "sublimation": RI_RAINBOW,

    /* Brushed metal: engraving takes the colour of the material, not of ink. */
    "laser engraving": "linear-gradient(135deg,#e4e8ec 0%,#9aa3ab 42%,#5d656c 52%,#c2c9cf 100%)",

    /* A pressed impression, so light above and shadow below a raised edge. */
    "debossing": "linear-gradient(135deg,#f1ece3 0%,#cdc3b4 42%,#9a8f80 52%,#e6dfd4 100%)",

    /* Stitches: a diagonal thread repeat rather than a single tone. */
    "embroidery": "repeating-linear-gradient(45deg,#3f4a5a 0 3px,#67748a 3px 6px)"
};

/**
 * The CSS background for one print colour swatch.
 *
 * `shape` is "round" for the 18px circle beside the closed dropdown and
 * "bar" for the 60x20 rows inside it. A method may offer a different drawing
 * for each; one that offers a single string uses it for both.
 *
 * Both call sites come through here. They used to each build the background
 * from the raw hex, which is how the header kept showing white after the
 * list had already been fixed.
 */
function riSwatchBackground(name, color, shape){
    const key = String(name || "").trim().toLowerCase();

    const uploaded = window.RI_PRINT_SWATCHES || {};

    /*
     * Matched case-insensitively on purpose. The keys are written in Liquid
     * and the names come from a metafield, and the two have no way to keep
     * their capitalisation in step.
     */
    for (const method in uploaded) {
        if (String(method).trim().toLowerCase() !== key) continue;
        if (!uploaded[method]) continue;

        // Single quotes: this lands inside a double-quoted style attribute.
        return `url('${uploaded[method]}') center / cover no-repeat`;
    }

    const built = RI_SWATCH_BACKGROUNDS[key];

    if (!built) return color;
    if (typeof built === "string") return built;

    return shape === "round" ? built.round : built.bar;
}

window.riSwatchBackground = riSwatchBackground;


// imprint color
function renderImprintColors(){
    const container = document.getElementById("ri-swatch-container");
    const header = document.getElementById("ri-dropdown-header");
    const hasPrintColorField =
        Boolean(container) &&
        Boolean(header) &&
        Boolean(window.STATE?.showPrintColor) &&
        normalizeRiList(window.IMPRINT_COLORS).length > 0;
    
    if(!container || !hasPrintColorField) return;

    header.onclick = function() {
        container.style.display = (container.style.display === "none" || container.style.display === "") ? "block" : "none";
    };

    const colors = normalizeRiList(window.IMPRINT_COLORS);
    let html = `<div style="padding: 10px; font-weight: bold; background: #ddd; font-size:12px;">Available Print Colors</div>`;

    colors.forEach(function(item){
        const parts = item.split("|");
        if(parts.length < 2) return;
        
        const name = parts[0].trim();
        const color = parts[1].trim();

        html += `
        <div class="ri-imprint-row" data-name="${name}" data-color="${color}" style="display: flex; justify-content: space-between; align-items: center; padding: 10px 15px; cursor: pointer; border-bottom: 1px solid #ddd; transition: 0.2s;">
            <span style="font-size: 14px; font-weight:500;">${name}</span>
            <div class="ri-color-palette" style="width: 60px; height: 20px; background: ${riSwatchBackground(name, color, "bar")}; border-radius: 4px; border: 1px solid rgba(0,0,0,0.1);"></div>
        </div>
        `;
    });

    container.innerHTML = html;
    initColorSelect();
}

window.renderImprintColors = renderImprintColors;


function initColorSelect(){
    const rows = document.querySelectorAll(".ri-imprint-row");
    const container = document.getElementById("ri-swatch-container");
    const placeholderText = document.getElementById("ri-selected-placeholder-text");
    const placeholderPalette = document.getElementById("ri-selected-placeholder-palette");
    const summaryColor = document.getElementById("my-color-name");

    rows.forEach(function(row){
        row.addEventListener("click", function(){
            // 1. Reset all rows
            rows.forEach(r => {
                r.style.background = "transparent";
                r.style.color = "#000";
                r.classList.remove("is-selected");
            });

            // 2. Highlight selected row
            this.style.background = "#222";
            this.style.color = "#fff";
            this.classList.add("is-selected");

            // 3. Get data from attributes
            const name = this.getAttribute("data-name");
            const color = this.getAttribute("data-color");

            // 4. Update Header (Text + Palette)
            if(placeholderText) placeholderText.innerText = name;
            if(placeholderPalette) {
                placeholderPalette.style.background = riSwatchBackground(name, color, "round");
                placeholderPalette.style.border = "1px solid rgba(0,0,0,0.2)";
            }

            // 5. Update Summary text
            if(summaryColor) summaryColor.innerText = name;

            // 6. Close dropdown
            container.style.display = "none";
        });

        // Hover effect for non-selected rows
        row.onmouseover = function() { 
            if(this.style.background !== "rgb(34, 34, 34)") this.style.background = "#f0f0f0"; 
        };
        row.onmouseout = function() { 
            if(this.style.background !== "rgb(34, 34, 34)") this.style.background = "transparent"; 
        };
    });
}






// Add to Cart button & View cart page connection  ........................



function connectCartButton() {
    const customBtn = document.querySelector('#trigger-real-atc');
    const realBtn   = document.querySelector('form[action*="/cart/add"] [name="add"]');
    if (!customBtn || !realBtn) return;
    realBtn.style.display = 'none';

    customBtn.addEventListener('click', async function (e) {
        e.preventDefault();
        e.stopPropagation();

        // 1. Determine Quantity and Price
        const simpleInput = document.getElementById('ri-simple-qty');
        let qty, subtotal, unitPrice;

        if (simpleInput) {
            qty = STATE.totalQty || parseInt(simpleInput.value || 0);
            unitPrice = STATE.unitPrice || 0;
            subtotal = STATE.subtotal || (qty * unitPrice);
        } else {
            qty = STATE.totalQty || 0;
            unitPrice = STATE.unitPrice || 0;
            subtotal = STATE.subtotal || 0;
        }

        const setup = STATE.setupFee || 0;
        const total = STATE.grandTotal || (subtotal + setup);
        const minQty = Number(STATE.tiers?.[0]?.min || 1);
        if (qty < minQty) {
            if (typeof renderValidationPopup === "function") {
                renderValidationPopup(customBtn, `Minimum ${minQty} quantity required.`);
            }
            return;
        }

        // 2 & 3. Required option validations
        const colorItems = document.querySelectorAll('.ri-item');
        if (colorItems.length > 0 && !document.querySelector('.ri-item.is-active')) {
            if (typeof renderValidationPopup === "function") {
                renderValidationPopup(customBtn, requiredFieldMessage('Product Color'));
            }
            return;
        }

        const locationSelect = document.getElementById('ri-location-select');
        const hasLocationOptions = locationSelect && locationSelect.options.length > 1;
        const imprintColor = getSelectedPrintColor();
        const hasImprintOptions = document.querySelectorAll('.ri-imprint-row').length > 0;

        if (hasLocationOptions && !locationSelect.value) {
            if (typeof renderValidationPopup === "function") {
                renderValidationPopup(customBtn, requiredFieldMessage(getPrintLocationLabel()));
            }
            return;
        }
        
        if (hasImprintOptions && (!imprintColor || imprintColor === 'None')) {
            if (typeof renderValidationPopup === "function") {
                renderValidationPopup(customBtn, requiredFieldMessage(getPrintColorLabel()));
            }
            return;
        }

        const missingRequiredPropertyInput = findMissingRequiredPropertyInput();
        if (missingRequiredPropertyInput) {
            if (typeof renderValidationPopup === "function") {
                renderValidationPopup(customBtn, requiredFieldMessage(getPropertyLabel(missingRequiredPropertyInput)));
            }
            missingRequiredPropertyInput.focus?.();
            return;
        }

        if (isUploadArtworkRequiredMissing()) {
            if (typeof renderValidationPopup === "function") {
                renderValidationPopup(customBtn, 'Please upload an image.');
            }
            return;
        }

        if (qty <= 0) return;

        // 4. Form + variant lookup
        // NOTE: the customization property inputs (Artwork Image file, Custom Text,
        // Artwork Method radio, etc.) live in the #roman-tier-ui wrapper which is a
        // SIBLING of the <form> (inserted via form.parentNode.insertBefore), NOT
        // inside it — and the theme's product-form.js is bound to
        // <product-form-component> while this page uses <product-form>. So instead
        // of clicking the native button (which would drop those inputs) we take full
        // control and POST to /cart/add.js ourselves, gathering every property input
        // from the whole document. This also lets us replace-not-duplicate on edit.
        const form = document.querySelector('form[action*="/cart/add"]');
        if (!form) return;
        const idInput   = form.querySelector('[name="id"]');
        const variantId = idInput ? idInput.value : null;
        if (!variantId) return;

	        // 5. JS-computed properties (price/qty/handle + swatch hex + sizes)
	        const printColorLabel = getPrintColorLabel();
	        const printLocationLabel = getPrintLocationLabel();
	        const props = {
	            'Product Color':    STATE.selectedColor || '',
	            'Unit Price':       '$' + unitPrice.toFixed(2),
	            'Subtotal':         '$' + subtotal.toFixed(2),
	            'Setup Fee':        '$' + setup.toFixed(2),
            'Order Total':      '$' + total.toFixed(2),
            '_qty':             String(qty),
	            '_handle':          window.location.pathname.split('/').pop()
	        };
	        if (hasImprintOptions) {
	            props[printColorLabel] = imprintColor;
	            props['_ColorHex'] = document.getElementById('ri-selected-placeholder-palette')?.style.backgroundColor || '';
	        }
	        if (hasLocationOptions) {
	            props[printLocationLabel] = locationSelect.value;
	        }

        const sizeData = {};
        const sizeUpchargeData = {};
        document.querySelectorAll('#ri-size-grid input').forEach(i => {
            if (Number(i.value) > 0) {
                sizeData[i.dataset.size] = i.value;
                // riSizeUpcharge (not the out-of-scope getSimpleSizeUpchargeAmount)
                // so the saved upcharge matches what the size grid displayed.
                const sizeUpcharge = riSizeUpcharge(i.dataset.size);
                // A listed 0 is saved too, so the cart does not fall back to its
                // XL/2XL default for a product whose chart says no upcharge.
                if (Number(sizeUpcharge) > 0 || hasSizeUpcharge(i.dataset.size)) {
                    sizeUpchargeData[i.dataset.size] = Number(sizeUpcharge).toFixed(2);
                }
            }
        });
        if (Object.keys(sizeData).length > 0) props['_sizes'] = JSON.stringify(sizeData);
        // The cart knows nothing about our tier table — it lives in a product metafield
        // this page read and the cart never sees. Carry it on the line so a quantity
        // change in the cart can recompute the price instead of freezing the old one.
        if (STATE.tiers && STATE.tiers.length) {
            props['_tiers'] = JSON.stringify(STATE.tiers.map((t) => ({ min: t.min, p: t.sale_price })));
        }
        if (Object.keys(sizeUpchargeData).length > 0) props['_size_upcharges'] = JSON.stringify(sizeUpchargeData);

        // 6. Build FormData: variant, quantity, user property inputs, computed props
        const fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', String(qty));

        // Gather every user-entered property input from the whole document
        // (the customization wrapper is outside the form). Preserve files & radios.
        const seenProps = new Set();
        document.querySelectorAll(
            'input[name^="properties["], textarea[name^="properties["], select[name^="properties["]'
        ).forEach(el => {
            const name = el.name;
            if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
            if (el.type === 'file') {
                if (el.files && el.files.length) {
                    fd.append(name, el.files[0]);
                    seenProps.add(name);
                }
                return; // never append an empty file input
            }
            if (el.value == null || el.value === '') return;
            fd.append(name, el.value);
            seenProps.add(name);
        });

        // Carry the previously uploaded artwork when editing and the user did NOT
        // re-upload (a File cannot be re-injected into a file input, so we preserve
        // the original artwork property value — a CDN URL — as text instead).
        if (window._editArtwork && window._editArtwork.value && !seenProps.has(window._editArtwork.name)) {
            fd.append(window._editArtwork.name, window._editArtwork.value);
        }

        // Append JS-computed props (distinct keys, no collision with user inputs).
        Object.entries(props).forEach(([k, v]) => fd.append(`properties[${k}]`, v));

        // Request rendered sections so we can refresh the drawer in place.
        const cartDrawer = document.querySelector('cart-drawer');
        const sectionIds = (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function')
            ? cartDrawer.getSectionsToRender().map(s => s.id)
            : null;
        if (sectionIds) {
            fd.append('sections', sectionIds.join(','));
            fd.append('sections_url', window.location.pathname);
        }
        if (cartDrawer && typeof cartDrawer.setActiveElement === 'function') {
            cartDrawer.setActiveElement(document.activeElement);
        }

        let beforeCart = null;
        if (window._editLineKey) {
            try {
                beforeCart = await fetch('/cart.js', {
                    headers: { 'X-Requested-With': 'XMLHttpRequest' }
                }).then(r => r.json());
            } catch (err) {
                console.warn('ROMAN: failed to capture cart before edit add', err);
            }
        }

        // 7. Add the new line
        let addResp;
        try {
            addResp = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                body: fd
            }).then(r => r.json());
        } catch (err) {
            console.error('ROMAN: add to cart failed', err);
            return;
        }
        if (addResp && addResp.status && Number(addResp.status) >= 400) {
            if (typeof renderValidationPopup === 'function') {
                renderValidationPopup(customBtn, addResp.description || 'Could not add to cart.');
            }
            return;
        }

        // 8. Replace-not-duplicate: reconcile against the live cart using the
        //    original line key and original quantity captured from edit mode.
        //    Order matters — we ADD first, then adjust/remove the old line by key
        //    so index shifts never target the wrong line.
        let finalState = addResp;
        const editKey = window._editLineKey;
        if (editKey) {
            let mergedIntoOriginal = false;
            let afterCart = null;
            try {
                afterCart = await fetch('/cart.js', {
                    headers: { 'X-Requested-With': 'XMLHttpRequest' }
                }).then(r => r.json());
                const originalLine = Array.isArray(afterCart?.items)
                    ? afterCart.items.find(item => item.key === editKey)
                    : null;
                const beforeOriginalLine = Array.isArray(beforeCart?.items)
                    ? beforeCart.items.find(item => item.key === editKey)
                    : null;
                const originalQty = Number(window._editOriginalQuantity || beforeOriginalLine?.quantity || 0);
                mergedIntoOriginal = Boolean(
                    originalLine &&
                    originalQty > 0 &&
                    Number(originalLine.quantity || 0) > originalQty
                );
            } catch (err) {
                console.warn('ROMAN: could not verify live cart merge state', err);
            }

            const changeBody = mergedIntoOriginal
                ? { id: editKey, quantity: qty }
                : { id: editKey, quantity: 0 };
            if (sectionIds) {
                changeBody.sections = sectionIds;
                changeBody.sections_url = window.location.pathname;
            }
            try {
                finalState = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                    body: JSON.stringify(changeBody)
                }).then(r => r.json());
            } catch (err) {
                console.error('ROMAN: remove original line failed', err);
                finalState = afterCart || finalState;
            }
            // The old line's top-up must go with it, or its charge is orphaned.
            if (!mergedIntoOriginal) await riRemoveTopUpFor(editKey);

            // Clear edit state so a normal subsequent add never deletes anything.
            window._editLineKey = null;
            window._editOriginalQuantity = null;
            window._editArtwork = null;
            const keyEl = document.getElementById('ri-edit-line-key');
            if (keyEl) keyEl.value = '';
        }

        // 9. Top the cart up to the total the page quoted. Runs after the edit
        //    reconciliation above so the parent key is final.
        const parentKey = addResp && addResp.key;
        const topUp = parentKey ? await riAddPricingTopUp(parentKey, total) : null;

        // The section HTML we asked for came back with the add response, i.e.
        // rendered BEFORE the top-up line existed. Rendering it now would show a
        // subtotal missing the top-up, and — because rows are addressed by cart
        // index — the indices would no longer line up with the real cart, so the
        // masking pass hides the wrong row. Drop them and let the refresh fetch
        // sections that match the final cart.
        if (topUp && finalState && finalState.sections) {
            finalState = { ...finalState, sections: null };
        }

        // 10. Refresh the drawer in place, clear first-add empty state, then patch our custom tables in.
        // No cart:refresh dispatch here: refreshRomanCartDrawer already fires
        // cart:updated, and a second event just re-runs the entire patch pass.
        await refreshRomanCartDrawer(finalState, sectionIds || ['cart-drawer', 'cart-icon-bubble']);
    });
}




// ── Pricing top-up ───────────────────────────────────────────────────────────
// Shopify charges variant_price x quantity. It has no concept of our tier table,
// size upcharges or setup fee, so a line added at the variant price is always
// SHORT of the total the product page quoted. Close the gap with a $0.01 variant
// added at quantity = shortfall-in-cents, tagged so it can be removed with its
// parent line.
//
// Requires every variant to be priced at its floor (cheapest tier + upcharge).
// A line can only add money, so a variant priced above its floor yields a
// negative gap; that is logged and skipped rather than guessed at.
const RI_TOPUP_PARENT_KEY = '_ri_topup_for';

async function riAddPricingTopUp(parentKey, quotedTotal) {
    const variantId = (window.ROMAN_META || {}).adjustment_variant_id;
    if (!variantId) {
        console.warn('ROMAN: adjustment_variant_id not set, skipping price top-up');
        return null;
    }

    let cart;
    try {
        cart = await fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(r => r.json());
    } catch (err) {
        console.error('ROMAN: could not read cart for top-up', err);
        return null;
    }

    const line = (cart.items || []).find(i => i.key === parentKey);
    if (!line) {
        console.warn('ROMAN: parent line not found, skipping price top-up', parentKey);
        return null;
    }

    const quotedCents = Math.round(Number(quotedTotal || 0) * 100);
    const gapCents = quotedCents - Number(line.final_line_price || 0);

    if (gapCents === 0) return null;
    if (gapCents < 0) {
        console.warn(
            'ROMAN: quoted total is BELOW what Shopify charges by', Math.abs(gapCents),
            'cents. A variant is priced above its tier floor, so no top-up is possible.',
            { handle: line.handle, variantPrice: line.price, quotedCents }
        );
        return null;
    }

    const fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', String(gapCents));
    fd.append(`properties[${RI_TOPUP_PARENT_KEY}]`, parentKey);

    try {
        return await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: fd
        }).then(r => r.json());
    } catch (err) {
        console.error('ROMAN: price top-up failed', err);
        return null;
    }
}

// Remove the top-up that belongs to a parent line (used when the line is removed
// or replaced), otherwise the charge is orphaned in the cart.
async function riRemoveTopUpFor(parentKey) {
    if (!parentKey) return;
    try {
        const cart = await fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(r => r.json());
        const orphan = (cart.items || []).find(i => (i.properties || {})[RI_TOPUP_PARENT_KEY] === parentKey);
        if (!orphan) return;
        await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: orphan.key, quantity: 0 })
        });
    } catch (err) {
        console.error('ROMAN: could not remove orphaned top-up', err);
    }
}

// ── Roman cart-rendering helpers ─────────────────────────────────────────────
// Escape a value for safe insertion as innerHTML.
function riEsc(v) {
    return String(v == null ? '' : v)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}
// Strip HTML tags from a rich-text value down to plain text (used for Custom Text).
function riStripTags(html) {
    const tmp = document.createElement('div');
    tmp.innerHTML = String(html == null ? '' : html);
    return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim();
}
// Derive a basename (filename) from a URL or path value.
function riBasename(val) {
    if (!val) return '';
    let s = String(val).split(/[?#]/)[0];
    s = s.substring(s.lastIndexOf('/') + 1);
    try { s = decodeURIComponent(s); } catch (e) {}
    return s;
}
function riIsImageUrl(val) {
    const s = String(val || '');
    return /^https?:\/\//i.test(s) && /\.(png|jpe?g|gif|svg|webp|bmp)(\?|#|$)/i.test(s);
}

// Build a clean left/right two-column table of all public line-item properties.
// Left column = field name, right column = customer's value. Internal keys
// (starting with "_") are excluded from the raw dump but their derived info
// (color swatch, size breakdown) is surfaced.
function renderRiPropsTable(item, options = {}) {
    const p = item.properties || {};
    const priceKeys   = ['Unit Price', 'Subtotal', 'Setup Fee', 'Order Total'];
    const textLimit = options.textLimit || 35;
    const priceMode = options.priceMode || 'drawer';
    const artworkKeys = ['Artwork Image', 'Artwork Image (Combined)'];
    const textKeys    = [
        { key: 'Text 1', label: 'Text 1' },
        { key: 'Custom Text', label: 'Text 1' },
        { key: 'Text 2', label: 'Text 2' },
        { key: 'Custom Text (Combined)', label: 'Text 2' }
    ];
    const rows = [];

    const addRow = (label, valueHtml, className = '') =>
        rows.push(
            `<div class="ri-prop-row${className ? ` ${className}` : ''}">` +
            `<span class="ri-prop-label">${riEsc(label)}:</span>` +
            `<span class="ri-prop-value">${valueHtml}</span>` +
            `</div>`
        );

    // Product Color
    if (p['Product Color']) addRow('Product Color', riEsc(p['Product Color']));

    // Print Color (with hex swatch from _ColorHex). Fallback supports older cart lines.
    const printColor = getStoredPrintColor(p);
    if (printColor && printColor !== 'N/A') {
        const hex = p['_ColorHex'] || printColor;
        addRow('Print Color',
            `<span class="ri-swatch" style="background:${riEsc(hex)}"></span><span>${riEsc(printColor)}</span>`);
    }

    // Print Location. Fallback supports older cart lines.
    const printLocation = getStoredPrintLocation(p);
    if (printLocation && printLocation !== 'Not selected')
        addRow('Print Location', riEsc(printLocation));

    const hasArtworkImage = artworkKeys.some(k => p[k]);

    // Artwork Method
    if (p['Artwork Method'] && !hasArtworkImage) addRow('Artwork Method', riEsc(p['Artwork Method']));

    // Artwork image: show the snapshot only when possible.
    artworkKeys.forEach(k => {
        if (!p[k]) return;
        const val  = p[k];
        let cell;
        if (riIsImageUrl(val)) {
            cell = `<a href="${riEsc(val)}" target="_blank" rel="noopener" class="ri-art-link">` +
                   `<img class="ri-art-thumb" src="${riEsc(val)}" alt="Artwork"></a>`;
        } else if (/^https?:\/\//i.test(String(val))) {
            cell = `<a href="${riEsc(val)}" target="_blank" rel="noopener" class="ri-art-link">View artwork</a>`;
        } else {
            cell = riEsc('Artwork uploaded');
        }
        addRow('Artwork Method', cell, 'ri-artwork-row');
    });

    // Size breakdown parsed from _sizes JSON
    if (p['_sizes']) {
        try {
            const sizes = JSON.parse(p['_sizes']);
            const upcharges = p['_size_upcharges'] ? JSON.parse(p['_size_upcharges']) : {};
            // _sizes is frozen at add time and Shopify forbids editing line properties, so
            // after a +/- in the cart it would read 'S: 10' on a line of 11. With exactly
            // one size the live quantity says it all, so derive rather than trust.
            const sizeNames = Object.keys(sizes);
            if (sizeNames.length === 1 && options.liveQuantity != null) {
                sizes[sizeNames[0]] = options.liveQuantity;
            }
            const parts = Object.keys(sizes)
                .map(s => {
                    // Saved value wins; then a "+$x" in the name; then the apparel
                    // default (XL +0.20, XXL +0.25) so even a line whose _size_upcharges
                    // never got saved still shows the upcharge. Small/Medium/Large resolve
                    // to nothing here — they genuinely carry no upcharge.
                    let up = upcharges[s];
                    if (up == null || up === '') up = String(s).match(/\+\$?([\d.]+)/)?.[1];
                    if (up == null || up === '') {
                        const norm = String(s).replace(/\s*\+\$?.*$/i, '').trim().toLowerCase();
                        if (norm === 'xl') up = 0.20;
                        else if (['xxl', '2xl', '2x'].includes(norm)) up = 0.25;
                    }
                    const amount = riMoneyFromNumber(up);
                    const cleanSize = String(s).replace(/\s*\+\$[\d.]+/i, '').trim();
                    const sizeLabel = amount ? `${cleanSize} (${amount})` : cleanSize;
                    return `${riEsc(sizeLabel)}: ${riEsc(sizes[s])}`;
                })
                .join('; ');
            if (parts) addRow('Sizes', parts);
        } catch (e) {}
    }

    const seenTextLabels = new Set();
    textKeys.forEach(({ key, label }) => {
        if (!p[key] || seenTextLabels.has(label)) return;
        const txt = riTruncateText(p[key], textLimit);
        if (txt) {
            // ri-text-row: clip long customer text to ONE line with an ellipsis (CSS),
            // instead of letting it wrap to two lines and shove the row apart.
            addRow(label, riEsc(txt), 'ri-text-row');
            seenTextLabels.add(label);
        }
    });

    // Any other public (non "_") property not already handled — future-proof.
    const handled = new Set([
        'Product Color', 'Print Color', 'Imprint Color', 'Print Location', 'Imprint Location', 'Artwork Method',
        ...priceKeys, ...artworkKeys, ...textKeys.map(({ key }) => key)
    ]);
    Object.keys(p).forEach(k => {
        if (k.charAt(0) === '_' || handled.has(k) || !p[k]) return;
        addRow(k, riEsc(riStripTags(p[k])));
    });

    // Price breakdown as a sub-section of the same table. The line subtotal comes
    // from the live cart, NOT the 'Order Total' property: that property is frozen
    // at the quantity the line was added with, so it goes stale the moment the
    // shopper changes quantity in the cart.
    const priceRows = [];
    if (p['Setup Fee']) {
        priceRows.push(
            `<div class="ri-prop-row ri-price-row">` +
            `<span class="ri-prop-label">Setup Fee:</span>` +
            `<span class="ri-prop-value">${riEsc(p['Setup Fee'])}</span></div>`
        );
    }
    if (priceMode !== 'main' && options.lineTotal) {
        priceRows.push(
            `<div class="ri-prop-row ri-price-row ri-price-total">` +
            `<span class="ri-prop-label">Subtotal:</span>` +
            `<span class="ri-prop-value">${riEsc(options.lineTotal)}</span></div>`
        );
    }

    return `<div class="ri-props-list">${rows.join('')}${priceRows.join('')}</div>`;
}

// Which sizes are on this line? Drives everything below:
//   0 sizes (tote bag, shot glass) -> quantity is unambiguous.
//   1 size  ('S: 10')              -> quantity IS that size's count. Unambiguous.
//   2+ sizes ('S: 5; XL: 5')       -> '+1' has no answer. Only the product page's
//                                     size grid can express it.
function riLineSizeNames(item) {
    try { return Object.keys(JSON.parse((item.properties || {})['_sizes'] || '{}')); }
    catch (e) { return []; }
}

function riLineIsAmbiguous(item) {
    return riLineSizeNames(item).length > 1;
}

// Unit price at a given quantity, straight off the tier table stored on the line.
// Returns null when the line predates _tiers, so callers leave old lines alone.
function riUnitPriceFor(item, qty) {
    const p = item.properties || {};
    let tiers = [];
    try { tiers = JSON.parse(p['_tiers'] || '[]'); } catch (e) { return null; }
    if (!tiers.length) return null;

    const tier = tiers.filter((t) => qty >= Number(t.min)).pop() || tiers[0];
    let each = Number(tier?.p || 0);

    // A single-size line carries that size's upcharge on every unit.
    const names = riLineSizeNames(item);
    if (names.length === 1) {
        try { each += Number(JSON.parse(p['_size_upcharges'] || '{}')[names[0]] || 0); } catch (e) {}
    }
    return each;
}

function riSetupFeeFor(item) {
    const raw = String((item.properties || {})['Setup Fee'] || '');
    return Number(raw.replace(/[^0-9.]/g, '')) || 0;
}

// What the product page WOULD quote for this line at this quantity. null = don't touch.
function riQuotedTotalFor(item, qty) {
    if (riLineIsAmbiguous(item)) return null;
    const each = riUnitPriceFor(item, qty);
    if (each == null) return null;
    return (qty * each) + riSetupFeeFor(item);
}

function riTopUpFor(cart, item) {
    return (cart.items || []).find((i) => (i.properties || {})[RI_TOPUP_PARENT_KEY] === item.key) || null;
}

// The true cost of a line = what Shopify charges for it PLUS its top-up. Reading
// final_line_price alone reported 10 x $2.50 = $25.00 on a line the customer pays
// $74.95 for, because the other $49.95 sits on the hidden top-up line.
function riTrueLineCents(cart, item) {
    const topUp = riTopUpFor(cart, item);
    return Number(item.final_line_price || 0) + Number(topUp?.final_line_price || 0);
}

// Build the "Edit Order" URL that carries the line key so the product page can
// prefill from the exact cart line and replace-not-duplicate on re-add.
function riBuildEditUrl(item) {
    const p = item.properties || {};
    const handle = p['_handle'] || item.handle;
    const q = (v) => encodeURIComponent(v || '');
    return `/products/${handle}?edit=1` +
        `&key=${q(item.key)}` +
        `&color=${q(p['Product Color'])}` +
        `&imprintColor=${q(getStoredPrintColor(p))}` +
        `&location=${q(getStoredPrintLocation(p))}` +
        `&qty=${q(p['_qty'] || item.quantity)}` +
        `&sizes=${q(p['_sizes'])}`;
}


// A top-up is meaningless without the line it belongs to. The theme's own Remove
// button deletes the product line directly and knows nothing about top-ups, so an
// orphan would be left behind. Because the row is hidden, that reads to the
// shopper as an EMPTY cart that still charges money. Sweep any orphan whose
// parent key is no longer in the cart. This also covers a cart left containing
// nothing but a fee line.
let _riSweepingOrphans = false;

async function riSweepOrphanTopUps(cart) {
    if (_riSweepingOrphans) return false;

    const items = cart.items || [];
    const liveKeys = new Set(items.map(i => i.key));
    const orphans = items.filter((i) => {
        const parent = (i.properties || {})[RI_TOPUP_PARENT_KEY];
        return parent && !liveKeys.has(parent);
    });
    if (!orphans.length) return false;

    _riSweepingOrphans = true;
    try {
        let state = null;
        for (const orphan of orphans) {
            state = await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: JSON.stringify({ id: orphan.key, quantity: 0 })
            }).then(r => r.json());
        }
        // Always re-render, including into an empty cart: skipping it left the swept
        // top-up row frozen on screen, since nothing else repaints the drawer.
        await refreshRomanCartDrawer(state, ['cart-drawer', 'cart-icon-bubble']);
        return true;
    } catch (err) {
        console.error('ROMAN: could not sweep orphaned top-ups', err);
        return false;
    } finally {
        _riSweepingOrphans = false;
    }
}

// The theme's +/- buttons call /cart/change.js, which can only alter a quantity —
// Shopify line-item properties are immutable, and the theme knows nothing of tiers
// or top-ups. So after it changes qty 10 -> 11, Shopify bills one extra unit at the
// $2.50 variant price while the page quotes $5.00: the cart under-charges by the gap
// on every unit added. The top-up's quantity IS the gap in cents, so re-sizing it is
// a single change call — no remove-and-re-add, no new line key.
let _riRepricing = false;

async function riRepriceChangedLines(cart) {
    if (_riRepricing) return false;

    const work = [];
    (cart.items || []).forEach((item) => {
        if ((item.properties || {})[RI_TOPUP_PARENT_KEY]) return; // a top-up itself
        const quoted = riQuotedTotalFor(item, item.quantity);
        if (quoted == null) return; // ambiguous, or a line added before _tiers existed

        const gapCents = Math.round(quoted * 100) - Number(item.final_line_price || 0);
        if (gapCents < 0) return; // variant priced above its tier floor; a line can only add

        const topUp = riTopUpFor(cart, item);
        if (Number(topUp?.quantity || 0) === gapCents) return; // already correct
        work.push({ item, topUp, gapCents });
    });
    if (!work.length) return false;

    _riRepricing = true;
    try {
        let state = null;
        for (const { item, topUp, gapCents } of work) {
            if (topUp) {
                state = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                    body: JSON.stringify({ id: topUp.key, quantity: gapCents })
                }).then((r) => r.json());
            } else if (gapCents > 0) {
                await riAddPricingTopUp(item.key, gapCents / 100 + Number(item.final_line_price || 0) / 100);
                state = null;
            }
        }
        await refreshRomanCartDrawer(state, ['cart-drawer', 'cart-icon-bubble']);
        return true;
    } catch (err) {
        console.error('ROMAN: could not reprice after quantity change', err);
        return false;
    } finally {
        _riRepricing = false;
    }
}

// Close the drawer once the shopper removes their last product. Only fires on the
// TRANSITION to empty, never merely because the cart IS empty: patchCartDrawer also
// runs when the shopper opens an already-empty drawer to read 'Your cart is empty',
// and closing it in their face there would be a bug, not a feature.
let _riHadRealProducts = false;

function riCloseDrawerIfEmptied(cart) {
    if (!Array.isArray(cart?.items)) return;

    if (cart.items.some((i) => !(i.properties || {})[RI_TOPUP_PARENT_KEY])) {
        _riHadRealProducts = true;
        return;
    }
    if (!_riHadRealProducts) return;
    _riHadRealProducts = false;

    document.querySelectorAll('cart-drawer').forEach(riForceCloseDrawer);
}

// Closing this drawer is not just close(). cart-drawer.js open() adds the 'active'
// class from inside its OWN setTimeout, and renderContents() calls open() from inside
// another one — so a close() merely queued alongside them gets undone by whichever
// timer fires last. The element is left .active: invisible, but still stretched over
// the page eating every click, with body.overflow-hidden and scroll-lock re-applied.
// That is the dead screen that only a reload clears. Racing the timers cannot win, so
// neutralise open() outright for a beat, then close.
function riForceCloseDrawer(drawer) {
    if (!drawer || typeof drawer.close !== 'function') return;

    drawer.open = () => {}; // own property, shadows the prototype method
    try { drawer.close(); } catch (err) { console.error('ROMAN: drawer close failed', err); }

    setTimeout(() => {
        delete drawer.open; // restore the prototype's open() for the next add-to-cart

        // Belt and braces for an open() that already slipped through on a timer we
        // never saw: strip the state it would have left behind.
        drawer.classList.remove('active', 'open');
        document.body.classList.remove('overflow-hidden');
        document.documentElement.removeAttribute('scroll-lock');
    }, 400); // clear of close()'s own 0.3s Motion timeline
}

// Raise/lower a white veil + spinner over the drawer while the cart re-renders,
// so the unpatched Liquid frame (raw prices, fee lines) never shows. The class
// goes on the OUTER <cart-drawer>, which survives renderContents' inner swap. A
// safety timer always lowers it, so a render that never repaints can't strand it.
let _riCartLoadingTimer = null;

function riSetCartLoading(on) {
    const drawers = document.querySelectorAll('cart-drawer');
    if (!drawers.length) return;

    if (on) {
        // Only veil an OPEN drawer — never flash a spinner over a closed one
        // (e.g. a quantity edit on the cart page, or a stray click).
        let veiled = false;
        drawers.forEach((d) => {
            if (d.classList.contains('active')) { d.classList.add('ri-cart-loading'); veiled = true; }
        });
        if (!veiled) return;
        clearTimeout(_riCartLoadingTimer);
        _riCartLoadingTimer = setTimeout(() => riSetCartLoading(false), 4000);
    } else {
        clearTimeout(_riCartLoadingTimer);
        drawers.forEach((d) => d.classList.remove('ri-cart-loading'));
    }
}

// Raise the veil the instant a cart control is pressed — BEFORE the theme's own
// handler fires its /cart/change round-trip and re-renders — so the unpatched
// frame is already hidden. Capture phase + pointerdown to beat the theme's click.
document.addEventListener('pointerdown', (event) => {
    const t = event.target;
    if (!t || !t.closest) return;
    const hit = t.closest(
        '.cart-item__quantity button, quantity-selector-component button, .quantity__button,' +
        ' cart-remove-button, .cart-item__remove button, [data-ri-remove-line], a.cart-item__remove'
    );
    if (hit && t.closest('cart-drawer.active')) riSetCartLoading(true);
}, true);

// Hide the top-up rows with CSS, BEFORE any JS runs, so they never paint even for
// a frame. riMaskTopUpLines tags rows by index AFTER a render, which leaves a
// window where the theme's freshly-rendered '$0.01 Setup & Volume Pricing' rows
// flash visible — most obvious when removing a product from a multi-line cart,
// where the drawer re-renders with the fee lines showing before we mask them.
// Every cart row carries <a href="{item.url}"> to its product, so a persistent
// rule keyed on the top-up's variant id / handle hides the row the instant it
// renders. The rule is injected once and refined as we learn the real line urls.
function riInjectTopUpHideCss(cart, explicitVariantId) {
    const frags = new Set();
    if (explicitVariantId) frags.add('variant=' + explicitVariantId);
    (cart && cart.items || []).forEach((i) => {
        if (!(i.properties || {})[RI_TOPUP_PARENT_KEY]) return;
        if (i.variant_id) frags.add('variant=' + i.variant_id);
        const path = String(i.url || '').split('?')[0];
        if (path) frags.add(path); // /products/<topup-handle>
    });
    if (!frags.size) return;

    // Accumulate across calls: a later render with fewer items must not drop a
    // fragment we already know, or the rule would stop hiding on that pass.
    if (!window._riTopUpFrags) window._riTopUpFrags = new Set();
    let changed = false;
    frags.forEach((f) => { if (!window._riTopUpFrags.has(f)) { window._riTopUpFrags.add(f); changed = true; } });

    let style = document.getElementById('ri-topup-hide-css');
    if (!style) {
        style = document.createElement('style');
        style.id = 'ri-topup-hide-css';
        document.head.appendChild(style);
        changed = true;
    }
    if (!changed) return;

    // " and \ can't appear in a url/variant fragment, so no escaping needed.
    const sel = [...window._riTopUpFrags]
        .map((f) => `.cart-item:has(a[href*="${f}"])`)
        .join(',');
    style.textContent = sel + '{display:none !important;}';
}

// The top-up line is a pricing mechanism, not something the shopper chose, so
// keep it out of the cart UI: hide its row, and count real product lines rather
// than units (its quantity is a number of CENTS, which otherwise pins the header
// bubble at "99+" forever).
function riMaskTopUpLines(cart) {
    const items = cart.items || [];

    items.forEach((item, idx) => {
        if (!(item.properties || {})[RI_TOPUP_PARENT_KEY]) return;
        const lineIndex = idx + 1;
        document.querySelectorAll(
            `#CartItem-${lineIndex}, [data-line="${lineIndex}"], [data-cart-item-index="${lineIndex}"]`
        ).forEach((row) => row.classList.add('ri-topup-line'));
    });

}

// The theme paints the count bubble in three places: two share id="cart-icon-bubble"
// (so renderContents' getElementById only ever updates the FIRST), and the mobile
// toolbar's belongs to a different section that renderContents never touches. Left
// alone, the copies keep a stale count after the cart empties. They also count
// UNITS, and a top-up's units are CENTS — thousands of them — which pins the bubble
// at '99+'. So drive every bubble from the real product-line count ourselves.
function riSyncCartCount(cart) {
    if (!Array.isArray(cart?.items)) return;

    const realLines = cart.items.filter((i) => !(i.properties || {})[RI_TOPUP_PARENT_KEY]).length;
    const text = String(realLines);

    document.querySelectorAll('[data-cart-count]').forEach((el) => {
        if (el.textContent.trim() !== text) el.textContent = text;
    });

    // An empty cart renders no bubble at all in Liquid. `.cart-count-bubble:empty`
    // can't do it for us — the bubble always holds two spans, so it is never :empty.
    document.querySelectorAll('.cart-count-bubble').forEach((el) => {
        el.style.display = realLines === 0 ? 'none' : '';
    });
}

// ── Cart Drawer Patch ────────────────────────────────────────────────────────
// cartData: an already-fetched cart object (the /cart/change.js response carries
// one). Passing it keeps this function synchronous up to the DOM writes, so the
// rows repaint in the same task the theme swapped the section HTML in and the
// browser never paints a frame of unpatched Liquid markup.
async function patchCartDrawer(cartData) {
    try {
        const cart = (cartData && Array.isArray(cartData.items))
            ? cartData
            : await fetch('/cart.js').then(r => r.json());

        // Persist the CSS hide as soon as we know the top-up line urls, so any
        // subsequent re-render hides the fee rows with no visible flash.
        riInjectTopUpHideCss(cart);

        // Hide the fee row before the sweep round-trips, so removing the last product
        // never flashes it as the only line in the cart.
        syncRomanCartEmptyState(cart);
        riSyncCartCount(cart);

        // Orphans first: a top-up whose product line is gone must not survive,
        // and the sweep re-renders, so there is nothing left to paint this pass.
        if (await riSweepOrphanTopUps(cart)) {
            riCloseDrawerIfEmptied(cart);
            return;
        }

        // Before the per-line loop: top-ups have no 'Unit Price' and would be
        // skipped by the early return below.
        // A quantity changed in the cart? Re-size its top-up before painting, or the
        // row would show — and the shopper would be charged — the old quantity's gap.
        if (await riRepriceChangedLines(cart)) return;

        riMaskTopUpLines(cart);
        syncRomanCartEmptyState(cart);
        riCloseDrawerIfEmptied(cart);

        cart.items.forEach((item, idx) => {
            const lineIndex = idx + 1;

            if (!item.properties || !item.properties['Unit Price']) return;

            // Live prices from the cart, so they track quantity changes and match
            // what Shopify actually charges. The 'Unit Price'/'Order Total'
            // properties are only a snapshot of the add-to-cart form.
            // Prefer the tier price over item.final_price: the variant is deliberately
            // priced at its tier FLOOR ($2.50) with the rest carried by the top-up, so
            // final_price alone showed the shopper a unit price they never pay.
            const each = riUnitPriceFor(item, item.quantity);
            const unitPrice  = each == null ? riMoneyFromCents(item.final_price) : money(each);
            const lineTotal  = riMoneyFromCents(riTrueLineCents(cart, item));

            // A single line index can appear in BOTH the mini-cart drawer and the
            // main cart page at once (duplicate data-line / CartItem ids), so patch
            // EVERY matching row rather than just the first.
            const rows = document.querySelectorAll(
                `#CartItem-${lineIndex}, #CartDrawer [data-line="${lineIndex}"], [data-line="${lineIndex}"], [data-cart-item-index="${lineIndex}"]`
            );
            if (!rows.length) return;

            const editUrl = riBuildEditUrl(item);
            const itemActions =
                `<div class="ri-edit-order-wrap">` +
                `<a class="ri-edit-order-btn" href="${riEsc(editUrl)}">Edit Order</a>` +
                `<button class="ri-remove-order-btn" type="button" data-ri-remove-line="${lineIndex}">Remove</button>` +
                `</div>`;

            rows.forEach(row => {
                const isDrawerRow = Boolean(row.closest('.cart-drawer, cart-drawer-items, #CartDrawer'));
                const tableHtml = renderRiPropsTable(item, {
                    textLimit: isDrawerRow ? 35 : 60,
                    priceMode: isDrawerRow ? 'drawer' : 'main',
                    liveQuantity: item.quantity,
                    lineTotal
                });

                // Bail out when this row's rendered state is unchanged. Every write
                // below is observed by _riObserver, which schedules another patch —
                // without this guard that loops a /cart.js fetch every 300ms forever.
                // Includes the live price and quantity: without them a quantity
                // change on an existing row would be skipped as "unchanged".
                const signature = [unitPrice, lineTotal, item.quantity, editUrl, tableHtml].join('|');
                if (row.dataset.riSig === signature) return;
                row.dataset.riSig = signature;

                // Must stay below the guard: classList.add fires an attribute
                // mutation on every call, which would retrigger _riObserver forever.
                row.classList.add('ri-custom-cart-item');
                row.dataset.riAmbiguous = String(riLineIsAmbiguous(item));

                row.querySelectorAll('.cart-item__old-price, s').forEach(el => {
                    el.style.display = 'none';
                });

                // The Price and Total cells show the tier price and what the line
                // really costs (Jason, 30 Oct 2026). Shopify's own figures are the
                // variant's tier-floor price ($29.88 x 30 = $896.40) on a line the
                // shopper pays $41.55 a unit plus setup for, through the hidden
                // top-up. Both come from the live quantity, not the add-time
                // snapshot, so they follow a quantity change in the cart.
                row.querySelectorAll('.cart-item__price-wrapper .price').forEach(el => {
                    el.textContent = el.closest('.cart-item__totals') ? lineTotal : unitPrice;
                });

                const detailsCell = row.querySelector('.cart-item__details');
                const titleLink = detailsCell?.querySelector('.cart-item__name');
                if (isDrawerRow && titleLink && !detailsCell.querySelector('.ri-drawer-unit-price')) {
                    titleLink.insertAdjacentHTML('afterend', `<div class="ri-drawer-unit-price">${riEsc(unitPrice)}</div>`);
                }

                if (detailsCell) {
                    detailsCell.querySelectorAll('.ri-details-actions').forEach(el => el.remove());
                    let propsDiv = detailsCell.querySelector('.ri-properties');
                    if (!propsDiv) {
                        propsDiv = document.createElement('div');
                        propsDiv.className = 'ri-properties';
                        detailsCell.appendChild(propsDiv);
                    }
                    propsDiv.innerHTML = tableHtml;
                }

                if (isDrawerRow) {
                    // Actions sit under the quantity selector in the drawer.
                    const quantityCell = row.querySelector('.cart-item__quantity');
                    if (quantityCell) {
                        quantityCell.querySelectorAll('.ri-edit-order-wrap').forEach(el => el.remove());
                        quantityCell.insertAdjacentHTML('beforeend', itemActions);
                    }
                } else {
                    const removeCell = row.querySelector('.cart-item__remove');
                    if (removeCell && !removeCell.querySelector('.ri-edit-order-wrap')) {
                        removeCell.innerHTML = itemActions;
                    }
                }

                row.querySelectorAll('[data-ri-remove-line]').forEach(button => {
                    if (button.dataset.riBound) return;
                    button.dataset.riBound = 'true';
                    button.addEventListener('click', () => {
                        const container = row.closest('cart-items-component') || row.closest('cart-drawer-items');
                        container?.dispatchEvent(new CustomEvent('onLineItemRemove', {
                            detail: { line: Number(button.dataset.riRemoveLine) },
                            bubbles: true
                        }));
                    });
                });
            });
        });

        // The cart subtotal is left to the theme: it renders Shopify's real total,
        // whereas summing the 'Order Total' properties reported a stale figure that
        // never matched what the customer is charged.

        // Rows are patched — lower the veil so the finished layout shows.
        riSetCartLoading(false);
    } catch (err) {
        console.error('patchCartDrawer error:', err);
        riSetCartLoading(false); // never strand the veil on an error
    }
}




// On a multi-size line ('S: 5; XL: 5') the stepper is unanswerable: +1 could be
// either size, and Shopify won't let us rewrite _sizes to record which. Rather than
// guess — and have the wrong shirt printed — hand the shopper the size grid, which
// is the only control that can express what they mean. Capture phase, so the theme's
// own listener never sees the click.
document.addEventListener('click', (event) => {
    const button = event.target.closest?.('.quantity__button, [name="plus"], [name="minus"]');
    if (!button) return;

    const row = button.closest('.ri-custom-cart-item');
    const editUrl = row?.querySelector('.ri-edit-order-btn')?.getAttribute('href');
    if (!row || !editUrl || row.dataset.riAmbiguous !== 'true') return;

    event.preventDefault();
    event.stopPropagation();
    window.location.href = editUrl;
}, true);

// ── Events & Observers ───────────────────────────────────────────────────────
// cart:updated means the theme re-rendered the cart section from Liquid, which has
// none of the custom fields, so the rows must be repainted.
//
// Timing is load-bearing. This file is deferred from <head>, so it registers before
// cart.js does in connectedCallback, i.e. this listener runs FIRST and cart.js's
// handleCartUpdate runs after us and calls updateSections() a second time. Patching
// synchronously here gets silently wiped by that second render. requestAnimationFrame
// defers us until every listener has finished writing to the DOM, yet still runs
// before the browser paints, so the rows never flash unpatched.
const _riRepatch = (event) => {
    const cart = (event?.detail && Array.isArray(event.detail.items)) ? event.detail : undefined;
    requestAnimationFrame(() => patchCartDrawer(cart));
};
document.addEventListener('cart:updated', _riRepatch);
document.addEventListener('cart:refresh',  _riRepatch);

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchCartDrawer);
} else {
    patchCartDrawer();
}

const _riObserver = new MutationObserver(() => setTimeout(patchCartDrawer, 300));
const _riObserverOptions = { childList: true, subtree: true, attributes: true };
const _riDrawerEl = document.querySelector('#CartDrawer, #Cart-Drawer, .cart-drawer, .drawer__inner');
if (_riDrawerEl) _riObserver.observe(_riDrawerEl, _riObserverOptions);

// The cart drawer section is not rendered on the cart page (see sections/cart-drawer.liquid),
// so _riDrawerEl is null there and cart page rows had no backstop at all: any re-render
// that dropped the custom fields stayed broken until a reload.
document.querySelectorAll('cart-items-component').forEach((el) => {
    _riObserver.observe(el, _riObserverOptions);
});

// Product pages expose the adjustment variant id, so we can arm the CSS hide
// before the very first add renders anything.
riInjectTopUpHideCss(null, (window.ROMAN_META || {}).adjustment_variant_id);

window.addEventListener('load', () => {
    setTimeout(connectCartButton, 300);
    setTimeout(patchCartDrawer, 100);
});













function updateCustomizationSummary() {
    
    const qty = STATE.totalQty || 0;
    const unit = STATE.unitPrice || 0;
    const subtotal = STATE.subtotal || 0;
    const setup = STATE.setupFee || 0;
    const total = subtotal + setup;

    const qtyLine = document.getElementById("ri-qty-line");
    const subtotalShow = document.getElementById("ri-subtotal-show");
    const setupShow = document.getElementById("ri-setup-show");
    const finalTotal = document.getElementById("ri-final-total");

    if (qtyLine) qtyLine.innerText = String(qty);
    if (subtotalShow) subtotalShow.innerText = money(total);
    if (setupShow) setupShow.innerText = money(setup);
    if (finalTotal) finalTotal.innerText = money(total);
}




function updateFirstPageTotal(){

const subtotal = STATE.subtotal || 0;
const setup = STATE.setupFee || 0;


const total = subtotal + setup;

const el = document.getElementById("ri-first-total-price");

if(el){
el.innerText = "$" + total.toFixed(2);
}

}


// Expose summary updater for code that runs outside the Roman IIFE scope.
window.updateCustomizationSummary = updateCustomizationSummary;










})();


// ── Global Artwork Functions ──
window.ckSwitchTab = function(tab, el) {
    document.querySelectorAll('.ck-panel').forEach(p => p.classList.remove('active'));
    document.querySelectorAll('.ck-tab-item').forEach(t => t.classList.remove('active'));
    const panel = document.getElementById('ck-panel-' + tab);
    if (panel) panel.classList.add('active');
    if (el) el.classList.add('active');
};

window.ckToggleMain = function(showNow) {
    const sendAfter   = document.getElementById('ck-panel-sendafter');
    const imagePanel  = document.getElementById('ck-panel-image');

    // Show exactly one of the two: the upload controls belong to 'Add Now',
    // the email instructions to 'Send After Checkout'. This used to add
    // 'active' unconditionally, so CHOOSE FILE stayed on screen even after
    // the shopper chose to send artwork later.
    if (imagePanel) imagePanel.classList.toggle('active', !!showNow);
    if (sendAfter) sendAfter.style.display = showNow ? 'none' : 'block';
};

window.formatDoc = function(cmd, value) {
    document.execCommand(cmd, false, value || null);
};

window.applyRiTextareaFont = function(select) {
    if (!select) return;

    const textarea = select.previousElementSibling?.matches?.('textarea')
        ? select.previousElementSibling
        : null;

    if (!textarea) return;

    if (select.value) {
        const font = String(select.value).replace(/\\/g, "\\\\").replace(/'/g, "\\'");
        const fontValue = `'${font}', var(--font-body--family, sans-serif)`;
        textarea.style.setProperty('--ri-textarea-font', fontValue);
        textarea.style.setProperty(
            'font-family',
            fontValue,
            'important'
        );
    } else {
        textarea.style.removeProperty('--ri-textarea-font');
        textarea.style.setProperty('font-family', 'var(--font-body--family, inherit)', 'important');
    }
};

window.syncText = function(editorId, hiddenId) {
    const editor = document.getElementById(editorId);
    const hidden = document.getElementById(hiddenId);
    if (editor && hidden) hidden.value = editor.innerHTML;
};

window.handleDynamicPreview = function(input, id) {
    const file = input.files[0];
    if (!file) return;
    // A newly chosen file always wins over any carried (edit) artwork.
    window._editArtwork = null;
    const nameInput = document.getElementById('file-name-' + id);
    if (nameInput) nameInput.value = file.name;
    const reader = new FileReader();
    reader.onload = function(e) {
        const preview = document.getElementById('preview-container-' + id);
        const img     = document.getElementById('image-preview-snapshot-' + id);
        if (preview) preview.style.display = 'block';
        if (img)     img.src = e.target.result;
    };
    reader.readAsDataURL(file);
};

window.clearDynamicImage = function(id) {
    const fileInput = document.getElementById('artwork-file-' + id);
    const nameInput = document.getElementById('file-name-' + id);
    const preview   = document.getElementById('preview-container-' + id);
    const img       = document.getElementById('image-preview-snapshot-' + id);
    if (fileInput) fileInput.value = '';
    if (nameInput) nameInput.value = '';
    if (preview)   preview.style.display = 'none';
    if (img)       img.src = '';
    // Drop any carried (previously uploaded) artwork so it isn't re-added on edit.
    window._editArtwork = null;
};







// ── Final Rock Solid Prefill Logic ──
// ── Universal Prefill Logic (Works for All Product Types) ──
// Global-scope basename helper (the IIFE-scoped riBasename isn't visible here).
function riBasenameGlobal(val) {
    if (!val) return '';
    let s = String(val).split(/[?#]/)[0];
    s = s.substring(s.lastIndexOf('/') + 1);
    try { s = decodeURIComponent(s); } catch (e) {}
    return s;
}
function riStripTagsGlobal(html) {
    const tmp = document.createElement('div');
    tmp.innerHTML = String(html == null ? '' : html);
    return (tmp.textContent || tmp.innerText || '').trim();
}
function riStoredPrintLocationGlobal(p) {
    return p['Print Location'] || p['Imprint Location'] || '';
}
function riStoredPrintColorGlobal(p) {
    return p['Print Color'] || p['Imprint Color'] || '';
}

function prefillFromURL() {
    const params = new URLSearchParams(window.location.search);
    if (!params.get('edit')) return;

    console.log("ROMAN: Edit Mode - Universal Prefill Starting...");

    const urlKey      = params.get('key');
    const urlColor    = params.get('color');
    const urlQty      = params.get('qty');
    const urlLocation = params.get('location');
    const urlImprint  = params.get('imprintColor');
    const urlSizes    = params.get('sizes');

    // Persist the line key so connectCartButton can replace-not-duplicate on re-add.
    if (urlKey) {
        window._editLineKey = urlKey;
        let keyEl = document.getElementById('ri-edit-line-key');
        if (!keyEl) {
            keyEl = document.createElement('input');
            keyEl.type = 'hidden';
            keyEl.id = 'ri-edit-line-key';
            document.body.appendChild(keyEl);
        }
        keyEl.value = urlKey;
    }

    // Fetch the exact cart line (robust: reads the COMPLETE properties object,
    // avoids cramming everything into the URL). URL params remain a fallback.
    const startPrefill = (line) => {
        const P = (line && line.properties) || {};
        window._editOriginalQuantity = Number((line && line.quantity) || P['_qty'] || urlQty || 0);
        // Effective values: prefer the stored line property, fall back to URL param.
        const effColor    = P['Product Color']    || (urlColor    ? decodeURIComponent(urlColor)    : '');
        const effQty      = P['_qty']             || urlQty                                          || '';
        const effLocation = riStoredPrintLocationGlobal(P) || (urlLocation ? decodeURIComponent(urlLocation) : '');
        const effImprint  = riStoredPrintColorGlobal(P)    || (urlImprint  ? decodeURIComponent(urlImprint)  : '');
        const effSizesRaw = P['_sizes']           || (urlSizes    ? decodeURIComponent(urlSizes)    : '');

        const checkUILoaded = setInterval(() => {
            const uiWrapper = document.getElementById('roman-tier-ui');
            if (!uiWrapper) return;
            clearInterval(checkUILoaded);
            console.log("ROMAN: UI Detected, filling data...");

            // Product color
            const carouselItems = document.querySelectorAll('.ri-item');
            if (carouselItems.length > 0 && effColor) {
                const target = effColor.toLowerCase().trim();
                carouselItems.forEach(item => {
                    if ((item.dataset.color || '').toLowerCase().trim() === target) item.click();
                });
            }

            setTimeout(() => {
                // Sizes
                if (effSizesRaw) {
                    try {
                        const sizeData = JSON.parse(effSizesRaw);
                        const sizeInputs = document.querySelectorAll('#ri-size-grid input');
                        if (sizeInputs.length > 0) {
                            sizeInputs.forEach(input => {
                                const sName = input.dataset.size;
                                if (sizeData[sName]) {
                                    input.value = sizeData[sName];
                                    input.dispatchEvent(new Event('input', { bubbles: true }));
                                }
                            });
                            sizeInputs[0].dispatchEvent(new Event('blur', { bubbles: true }));
                        }
                    } catch (e) { console.warn("Size parsing failed or no sizes found."); }
                }

                // Simple quantity
                const simpleInput = document.getElementById('ri-simple-qty');
                if (simpleInput && effQty) {
                    simpleInput.value = effQty;
                    simpleInput.dispatchEvent(new Event('input', { bubbles: true }));
                    simpleInput.dispatchEvent(new Event('blur', { bubbles: true }));
                }

                // Imprint location
                const locSelect = document.getElementById('ri-location-select');
                if (locSelect && effLocation) {
                    locSelect.value = effLocation;
                    locSelect.dispatchEvent(new Event('change', { bubbles: true }));
                }

                // Imprint color
                if (effImprint) {
                    const targetImprint = effImprint.toLowerCase().trim();
                    document.querySelectorAll('.ri-imprint-row').forEach(row => {
                        if ((row.dataset.name || '').toLowerCase().trim() === targetImprint) row.click();
                    });
                }

                // ── Custom Text (rich editor + hidden inputs + display textareas) ──
                const setText = (val, editorId, hiddenId, displayId) => {
                    if (!val) return;
                    const hidden  = document.getElementById(hiddenId);
                    const editor  = document.getElementById(editorId);
                    const display = document.getElementById(displayId);
                    if (hidden)  hidden.value = val;                 // preserve original HTML
                    if (editor)  editor.innerHTML = val;             // show in contenteditable
                    if (display) display.value = riStripTagsGlobal(val); // plain-text textarea
                };
                setText(P['Text 1'] || P['Custom Text'],            'editor-only-text', 'hidden-only-text', 'ri-display-text-1');
                setText(P['Text 2'] || P['Custom Text (Combined)'], 'editor-both',      'hidden-both-text', 'ri-display-text-2');

                // ── Artwork Method radio ──
                if (P['Artwork Method']) {
                    document.querySelectorAll('input[name="properties[Artwork Method]"]').forEach(r => {
                        if (r.value === P['Artwork Method']) {
                            r.checked = true;
                            r.click(); // fires ckToggleMain(...) to show/hide the upload UI
                        }
                    });
                }

                // ── Previously uploaded artwork (cannot re-inject a File) ──
                // Show the old image as a preview + filename and carry its property
                // value so, if the user does NOT re-upload, the same image is kept.
                const artworkSpecs = [
                    { key: 'Artwork Image',            id: '1' },
                    { key: 'Artwork Image (Combined)', id: '2' }
                ];
                artworkSpecs.forEach(spec => {
                    const val = P[spec.key];
                    if (!val) return;
                    window._editArtwork = { name: `properties[${spec.key}]`, value: val };
                    const fileName = riBasenameGlobal(val) || 'Uploaded file';
                    const nameInput = document.getElementById('file-name-' + spec.id);
                    const preview   = document.getElementById('preview-container-' + spec.id);
                    const img       = document.getElementById('image-preview-snapshot-' + spec.id);
                    if (nameInput) nameInput.value = fileName;
                    if (/^https?:\/\//i.test(String(val))) {
                        if (preview) preview.style.display = 'block';
                        if (img) img.src = val;
                    }
                });

                setTimeout(() => {
                    const customSec = document.getElementById('ri-customization-step');
                    if (customSec) customSec.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 400);

            }, 800);
        }, 500);
    };

    if (urlKey) {
        fetch('/cart.js')
            .then(r => r.json())
            .then(cart => startPrefill((cart.items || []).find(i => i.key === urlKey) || null))
            .catch(() => startPrefill(null));
    } else {
        startPrefill(null);
    }
}


prefillFromURL();




function initOnePageDesign() {
    const custom = document.getElementById('ri-customization-step');
    if (custom) {
        custom.style.setProperty('display', 'block', 'important');

        if (typeof window.renderImprintColors === 'function') {
            window.renderImprintColors();
        }

        if (typeof window.updateDeliveryDate === 'function') {
            window.updateDeliveryDate();
        }

        if (typeof window.updateCustomizationSummary === 'function') {
            window.updateCustomizationSummary();
        }
    }
}

// run to after page load
window.addEventListener('load', () => {
    setTimeout(initOnePageDesign, 1500); 
});




